export const WARD_DISTRICT_REGIONS = [
  "Babayu,Bahi,Dodoma",
  "Bahi,Bahi,Dodoma",
  "Chali,Bahi,Dodoma",
  "Chibelela,Bahi,Dodoma",
  "Chikola,Bahi,Dodoma",
  "Chipanga,Bahi,Dodoma",
  "Ibihwa,Bahi,Dodoma",
  "Ibugule,Bahi,Dodoma",
  "Ilindi,Bahi,Dodoma",
  "Kigwe,Bahi,Dodoma",
  "Lamaiti,Bahi,Dodoma",
  "Makanda,Bahi,Dodoma",
  "Mpalanga,Bahi,Dodoma",
  "Mpamantwa,Bahi,Dodoma",
  "Msisi,Bahi,Dodoma",
  "Mtitaa,Bahi,Dodoma",
  "Mundemu,Bahi,Dodoma",
  "Mwitikira,Bahi,Dodoma",
  "Nondwa,Bahi,Dodoma",
  "Zanka,Bahi,Dodoma",
  "Buigiri,Chamwino,Dodoma",
  "Chiboli,Chamwino,Dodoma",
  "Chilonwa,Chamwino,Dodoma",
  "Chinugulu,Chamwino,Dodoma",
  "Dabalo,Chamwino,Dodoma",
  "Fufu,Chamwino,Dodoma",
  "Handali,Chamwino,Dodoma",
  "Haneti,Chamwino,Dodoma",
  "Huzi,Chamwino,Dodoma",
  "Idifu,Chamwino,Dodoma",
  "Igandu,Chamwino,Dodoma",
  "Ikowa,Chamwino,Dodoma",
  "Iringa Mvumi Zamani,Chamwino,Dodoma",
  "Itiso,Chamwino,Dodoma",
  "Loje,Chamwino,Dodoma",
  "Majeleko,Chamwino,Dodoma",
  "Makang'wa,Chamwino,Dodoma",
  "Manchali,Chamwino,Dodoma",
  "Manda,Chamwino,Dodoma",
  "Manzase,Chamwino,Dodoma",
  "Membe,Chamwino,Dodoma",
  "Mlowa Bwawani,Chamwino,Dodoma",
  "Mpwayungu,Chamwino,Dodoma",
  "Msamalo,Chamwino,Dodoma",
  "Msanga,Chamwino,Dodoma",
  "Muungano,Chamwino,Dodoma",
  "Mvumi Makulu,Chamwino,Dodoma",
  "Mvumi Mission,Chamwino,Dodoma",
  "Nghambaku,Chamwino,Dodoma",
  "Nhinhi,Chamwino,Dodoma",
  "Segala,Chamwino,Dodoma",
  "Zajilwa,Chamwino,Dodoma",
  "Chandama,Chemba,Dodoma",
  "Chemba,Chemba,Dodoma",
  "Churuku,Chemba,Dodoma",
  "Dalai,Chemba,Dodoma",
  "Farkwa,Chemba,Dodoma",
  "Goima,Chemba,Dodoma",
  "Gwandi,Chemba,Dodoma",
  "Jangalo,Chemba,Dodoma",
  "Kimaha,Chemba,Dodoma",
  "Kwamtoro,Chemba,Dodoma",
  "Lalta,Chemba,Dodoma",
  "Makorongo,Chemba,Dodoma",
  "Mondo,Chemba,Dodoma",
  "Mpendo,Chemba,Dodoma",
  "Mrijo,Chemba,Dodoma",
  "Msaada,Chemba,Dodoma",
  "Ovada,Chemba,Dodoma",
  "Paranga,Chemba,Dodoma",
  "Sanzawa,Chemba,Dodoma",
  "Songoro,Chemba,Dodoma",
  "Chahwa,Dodoma Municipal,Dodoma",
  "Chamwino,Dodoma Municipal,Dodoma",
  "Chang'ombe,Dodoma Municipal,Dodoma",
  "Chigongwe,Dodoma Municipal,Dodoma",
  "Chihanga,Dodoma Municipal,Dodoma",
  "Dodoma Makulu (Dom-Makulu),Dodoma Municipal,Dodoma",
  "Hazina,Dodoma Municipal,Dodoma",
  "Hombolo,Dodoma Municipal,Dodoma",
  "Ipagala,Dodoma Municipal,Dodoma",
  "Ipala,Dodoma Municipal,Dodoma",
  "Iyumbu,Dodoma Municipal,Dodoma",
  "Kikombo,Dodoma Municipal,Dodoma",
  "Kikuyu Kaskazini,Dodoma Municipal,Dodoma",
  "Kikuyu Kusini,Dodoma Municipal,Dodoma",
  "Kilimani,Dodoma Municipal,Dodoma",
  "Kiwanja cha Ndege,Dodoma Municipal,Dodoma",
  "Kizota,Dodoma Municipal,Dodoma",
  "Madukani,Dodoma Municipal,Dodoma",
  "Majengo,Dodoma Municipal,Dodoma",
  "Makole,Dodoma Municipal,Dodoma",
  "Makutupora,Dodoma Municipal,Dodoma",
  "Mbabala,Dodoma Municipal,Dodoma",
  "Mbalawala,Dodoma Municipal,Dodoma",
  "Miyuji,Dodoma Municipal,Dodoma",
  "Mkonze,Dodoma Municipal,Dodoma",
  "Mnadani,Dodoma Municipal,Dodoma",
  "Mpunguzi,Dodoma Municipal,Dodoma",
  "Msalato,Dodoma Municipal,Dodoma",
  "Mtumba,Dodoma Municipal,Dodoma",
  "Nala,Dodoma Municipal,Dodoma",
  "Ng'hong'honha,Dodoma Municipal,Dodoma",
  "Ntyuka,Dodoma Municipal,Dodoma",
  "Nzuguni,Dodoma Municipal,Dodoma",
  "Tambukareli,Dodoma Municipal,Dodoma",
  "Uhuru,Dodoma Municipal,Dodoma",
  "Viwandani,Dodoma Municipal,Dodoma",
  "Zuzu,Dodoma Municipal,Dodoma",
  "Bukoko,Igunga,Tabora",
  "Chabutwa,Igunga,Tabora",
  "Choma,Igunga,Tabora",
  "Igoweko (Igowero),Igunga,Tabora",
  "Igunga,Igunga,Tabora",
  "Igurubi,Igunga,Tabora",
  "Isakamaliwa,Igunga,Tabora",
  "Itumba,Igunga,Tabora",
  "Itunduru,Igunga,Tabora",
  "Kining'ila (Kining'inila),Igunga,Tabora",
  "Kinungu,Igunga,Tabora",
  "Mbutu,Igunga,Tabora",
  "Mwamashiga,Igunga,Tabora",
  "Mwamashimba,Igunga,Tabora",
  "Mwashiku,Igunga,Tabora",
  "Mwisi,Igunga,Tabora",
  "Nanga,Igunga,Tabora",
  "Ndembezi,Igunga,Tabora",
  "Ngulu,Igunga,Tabora",
  "Nguvumoja,Igunga,Tabora",
  "Nkinga,Igunga,Tabora",
  "Ntobo,Igunga,Tabora",
  "Nyandekwa,Igunga,Tabora",
  "Simbo,Igunga,Tabora",
  "Sungwizi,Igunga,Tabora",
  "Ziba,Igunga,Tabora",
  "Dung'unyi,Ikungi,Singida",
  "Ighombwe,Ikungi,Singida",
  "Iglansoni,Ikungi,Singida",
  "Ihanja,Ikungi,Singida",
  "Ikungi,Ikungi,Singida",
  "Irisya,Ikungi,Singida",
  "Iseke,Ikungi,Singida",
  "Issuna,Ikungi,Singida",
  "Iyumbu,Ikungi,Singida",
  "Kikio,Ikungi,Singida",
  "Kituntu,Ikungi,Singida",
  "Lighwa,Ikungi,Singida",
  "Mang'onyi,Ikungi,Singida",
  "Mgungira,Ikungi,Singida",
  "Minyughe,Ikungi,Singida",
  "Misughaa,Ikungi,Singida",
  "Mkiwa,Ikungi,Singida",
  "Mtunduru,Ikungi,Singida",
  "Muhintiri,Ikungi,Singida",
  "Mungaa,Ikungi,Singida",
  "Mwaru,Ikungi,Singida",
  "Ntuntu,Ikungi,Singida",
  "Puma,Ikungi,Singida",
  "Sepuka,Ikungi,Singida",
  "Siuyu,Ikungi,Singida",
  "Unyahati,Ikungi,Singida",
  "Kaselya,Iramba,Singida",
  "Kidaru,Iramba,Singida",
  "Kinampanda,Iramba,Singida",
  "Kiomboi,Iramba,Singida",
  "Kisiriri,Iramba,Singida",
  "Kyengege,Iramba,Singida",
  "Mbelekese,Iramba,Singida",
  "Mgongo,Iramba,Singida",
  "Mtekente,Iramba,Singida",
  "Mtoa,Iramba,Singida",
  "Ndago,Iramba,Singida",
  "Ndulungu,Iramba,Singida",
  "Ntwike,Iramba,Singida",
  "Shelui,Iramba,Singida",
  "Tulya,Iramba,Singida",
  "Ulemo,Iramba,Singida",
  "Urughu,Iramba,Singida",
  "Ichemba,Kaliua,Tabora",
  "Igagala,Kaliua,Tabora",
  "Igombe Mkulu,Kaliua,Tabora",
  "Igwisi,Kaliua,Tabora",
  "Kaliua,Kaliua,Tabora",
  "Kamsekwa,Kaliua,Tabora",
  "Kanindo,Kaliua,Tabora",
  "Kanoge,Kaliua,Tabora",
  "Kashishi,Kaliua,Tabora",
  "Kazaroho,Kaliua,Tabora",
  "Milambo,Kaliua,Tabora",
  "Mwongozo,Kaliua,Tabora",
  "Sasu,Kaliua,Tabora",
  "Seleli,Kaliua,Tabora",
  "Silambo,Kaliua,Tabora",
  "Ugunga,Kaliua,Tabora",
  "Ukumbisiganga,Kaliua,Tabora",
  "Ushokola,Kaliua,Tabora",
  "Usinge,Kaliua,Tabora",
  "Uyowa,Kaliua,Tabora",
  "Zugimlole,Kaliua,Tabora",
  "Bereko,Kondoa,Dodoma",
  "Bolisa,Kondoa,Dodoma",
  "Bumbuta,Kondoa,Dodoma",
  "Busi,Kondoa,Dodoma",
  "Changaa,Kondoa,Dodoma",
  "Chemchem,Kondoa,Dodoma",
  "Haubi,Kondoa,Dodoma",
  "Hondomairo,Kondoa,Dodoma",
  "Itaswi,Kondoa,Dodoma",
  "Itololo,Kondoa,Dodoma",
  "Kalamba,Kondoa,Dodoma",
  "Kikilo,Kondoa,Dodoma",
  "Kikore,Kondoa,Dodoma",
  "Kilimani,Kondoa,Dodoma",
  "Kingale,Kondoa,Dodoma",
  "Kinyasi,Kondoa,Dodoma",
  "Kisese,Kondoa,Dodoma",
  "Kolo,Kondoa,Dodoma",
  "Kondoa Mjini,Kondoa,Dodoma",
  "Kwadelo,Kondoa,Dodoma",
  "Masange,Kondoa,Dodoma",
  "Mnenia,Kondoa,Dodoma",
  "Pahi,Kondoa,Dodoma",
  "Salanka,Kondoa,Dodoma",
  "Serya,Kondoa,Dodoma",
  "Soera,Kondoa,Dodoma",
  "Suruke,Kondoa,Dodoma",
  "Thawi,Kondoa,Dodoma",
  "Chamkoroma,Kongwa,Dodoma",
  "Chitego,Kongwa,Dodoma",
  "Chiwe,Kongwa,Dodoma",
  "Hogoro,Kongwa,Dodoma",
  "Iduo,Kongwa,Dodoma",
  "Kibaigwa,Kongwa,Dodoma",
  "Kongwa,Kongwa,Dodoma",
  "Lenjulu,Kongwa,Dodoma",
  "Makawa,Kongwa,Dodoma",
  "Matongoro,Kongwa,Dodoma",
  "Mkoka,Kongwa,Dodoma",
  "Mlali,Kongwa,Dodoma",
  "Mtanana,Kongwa,Dodoma",
  "Nghumbi,Kongwa,Dodoma",
  "Ngomai,Kongwa,Dodoma",
  "Njoge,Kongwa,Dodoma",
  "Pandambili,Kongwa,Dodoma",
  "Sagara,Kongwa,Dodoma",
  "Sejeli,Kongwa,Dodoma",
  "Songambele,Kongwa,Dodoma",
  "Ugogoni,Kongwa,Dodoma",
  "Zoissa,Kongwa,Dodoma",
  "Aghondi,Manyoni,Singida",
  "Chikola,Manyoni,Singida",
  "Chikuyu,Manyoni,Singida",
  "Heka,Manyoni,Singida",
  "Idodyandole,Manyoni,Singida",
  "Ipande,Manyoni,Singida",
  "Isseke,Manyoni,Singida",
  "Itigi Majengo,Manyoni,Singida",
  "Itigi Mjini,Manyoni,Singida",
  "Kintinku,Manyoni,Singida",
  "Kitaraka,Manyoni,Singida",
  "Majiri,Manyoni,Singida",
  "Makanda,Manyoni,Singida",
  "Makuru,Manyoni,Singida",
  "Makutopora (Makutupora),Manyoni,Singida",
  "Manyoni,Manyoni,Singida",
  "Mgandu,Manyoni,Singida",
  "Mitundu,Manyoni,Singida",
  "Mkwese,Manyoni,Singida",
  "Muhalala,Manyoni,Singida",
  "Mvumi,Manyoni,Singida",
  "Mwamagembe,Manyoni,Singida",
  "Nkonko,Manyoni,Singida",
  "Rungwa,Manyoni,Singida",
  "Sanjaranda,Manyoni,Singida",
  "Sanza,Manyoni,Singida",
  "Saranda,Manyoni,Singida",
  "Sasajila,Manyoni,Singida",
  "Sasilo,Manyoni,Singida",
  "Solya,Manyoni,Singida",
  "Gumanga,Mkalama,Singida",
  "Ibaga,Mkalama,Singida",
  "Iguguno,Mkalama,Singida",
  "Ilunda,Mkalama,Singida",
  "Kikhonda,Mkalama,Singida",
  "Kinyangiri,Mkalama,Singida",
  "Matongo,Mkalama,Singida",
  "Miganga,Mkalama,Singida",
  "Mpambala,Mkalama,Singida",
  "Msingi,Mkalama,Singida",
  "Mwanga,Mkalama,Singida",
  "Mwangeza,Mkalama,Singida",
  "Nduguti,Mkalama,Singida",
  "Nkinto,Mkalama,Singida",
  "Berege,Mpwapwa,Dodoma",
  "Chipogoro,Mpwapwa,Dodoma",
  "Chitemo,Mpwapwa,Dodoma",
  "Chunyu,Mpwapwa,Dodoma",
  "Galigali,Mpwapwa,Dodoma",
  "Godegode,Mpwapwa,Dodoma",
  "Gulwe,Mpwapwa,Dodoma",
  "Ipera,Mpwapwa,Dodoma",
  "Iwondo,Mpwapwa,Dodoma",
  "Kibakwe,Mpwapwa,Dodoma",
  "Kimagai,Mpwapwa,Dodoma",
  "Kingiti,Mpwapwa,Dodoma",
  "Lufu,Mpwapwa,Dodoma",
  "Luhundwa,Mpwapwa,Dodoma",
  "Lumuma,Mpwapwa,Dodoma",
  "Lupeta,Mpwapwa,Dodoma",
  "Malolo,Mpwapwa,Dodoma",
  "Massa,Mpwapwa,Dodoma",
  "Matomondo,Mpwapwa,Dodoma",
  "Mazae,Mpwapwa,Dodoma",
  "Mbuga,Mpwapwa,Dodoma",
  "Mima,Mpwapwa,Dodoma",
  "Mlunduzi,Mpwapwa,Dodoma",
  "Mpwapwa Mjini,Mpwapwa,Dodoma",
  "Mtera,Mpwapwa,Dodoma",
  "Nghambi,Mpwapwa,Dodoma",
  "Pwaga,Mpwapwa,Dodoma",
  "Rudi,Mpwapwa,Dodoma",
  "Ving'hawe,Mpwapwa,Dodoma",
  "Wotta,Mpwapwa,Dodoma",
  "Budushi,Nzega,Tabora",
  "Bukene,Nzega,Tabora",
  "Igusule,Nzega,Tabora",
  "Ijanija,Nzega,Tabora",
  "Ikindwa,Nzega,Tabora",
  "Isagenhe,Nzega,Tabora",
  "Isanzu,Nzega,Tabora",
  "Itilo,Nzega,Tabora",
  "Itobo,Nzega,Tabora",
  "Kahama Nhalanga,Nzega,Tabora",
  "Karitu,Nzega,Tabora",
  "Kasela,Nzega,Tabora",
  "Lusu,Nzega,Tabora",
  "Magengati,Nzega,Tabora",
  "Mambali,Nzega,Tabora",
  "Mbogwe,Nzega,Tabora",
  "Miguwa,Nzega,Tabora",
  "Milambo Itobo,Nzega,Tabora",
  "Mizibaziba,Nzega,Tabora",
  "Mogwa,Nzega,Tabora",
  "Muhugi,Nzega,Tabora",
  "Mwakashanhala,Nzega,Tabora",
  "Mwamala,Nzega,Tabora",
  "Mwangoye,Nzega,Tabora",
  "Nata,Nzega,Tabora",
  "Ndala,Nzega,Tabora",
  "Nkiniziwa,Nzega,Tabora",
  "Nzega Mjini,Nzega,Tabora",
  "Nzega Ndogo,Nzega,Tabora",
  "Puge,Nzega,Tabora",
  "Semembela,Nzega,Tabora",
  "Shigamba,Nzega,Tabora",
  "Sigili,Nzega,Tabora",
  "Tongi,Nzega,Tabora",
  "Uduka,Nzega,Tabora",
  "Utwigu,Nzega,Tabora",
  "Wela,Nzega,Tabora",
  "Chabutwa,Sikonge,Tabora",
  "Igigwa,Sikonge,Tabora",
  "Ipole,Sikonge,Tabora",
  "Kiloleli (Kaloleli),Sikonge,Tabora",
  "Kiloli,Sikonge,Tabora",
  "Kipanga,Sikonge,Tabora",
  "Kipili,Sikonge,Tabora",
  "Kisanga,Sikonge,Tabora",
  "Kitunda,Sikonge,Tabora",
  "Misheni,Sikonge,Tabora",
  "Mole,Sikonge,Tabora",
  "Mpombwe,Sikonge,Tabora",
  "Ngoywa,Sikonge,Tabora",
  "Pangale,Sikonge,Tabora",
  "Sikonge,Sikonge,Tabora",
  "Tutuo,Sikonge,Tabora",
  "Usunga,Sikonge,Tabora",
  "Ipembe,Singida Municipal,Singida",
  "Kindai,Singida Municipal,Singida",
  "Majengo,Singida Municipal,Singida",
  "Mandewa,Singida Municipal,Singida",
  "Minga,Singida Municipal,Singida",
  "Misuna,Singida Municipal,Singida",
  "Mitunduruni (Mitunduru),Singida Municipal,Singida",
  "Mtamaa,Singida Municipal,Singida",
  "Mtipa,Singida Municipal,Singida",
  "Mughanga,Singida Municipal,Singida",
  "Mungumaji,Singida Municipal,Singida",
  "Mwankoko,Singida Municipal,Singida",
  "Uhamaka,Singida Municipal,Singida",
  "Unyambwa (Umyambwa),Singida Municipal,Singida",
  "Unyamikumbi,Singida Municipal,Singida",
  "Utemini,Singida Municipal,Singida",
  "Chemchem,Tabora Municipal,Tabora",
  "Cheyo,Tabora Municipal,Tabora",
  "Gongoni,Tabora Municipal,Tabora",
  "Ifucha,Tabora Municipal,Tabora",
  "Ikomwa,Tabora Municipal,Tabora",
  "Ipuli,Tabora Municipal,Tabora",
  "Isevya,Tabora Municipal,Tabora",
  "Itetemia,Tabora Municipal,Tabora",
  "Itonjanda,Tabora Municipal,Tabora",
  "Kabila,Tabora Municipal,Tabora",
  "Kakola,Tabora Municipal,Tabora",
  "Kalunde,Tabora Municipal,Tabora",
  "Kanyenye,Tabora Municipal,Tabora",
  "Kiloleni,Tabora Municipal,Tabora",
  "Kitete,Tabora Municipal,Tabora",
  "Malolo,Tabora Municipal,Tabora",
  "Mbugani,Tabora Municipal,Tabora",
  "Misha,Tabora Municipal,Tabora",
  "Mtendeni,Tabora Municipal,Tabora",
  "Ndevelwa,Tabora Municipal,Tabora",
  "Ng'ambo,Tabora Municipal,Tabora",
  "Ntalikwa,Tabora Municipal,Tabora",
  "Tambukareli,Tabora Municipal,Tabora",
  "Tumbi,Tabora Municipal,Tabora",
  "Uyui,Tabora Municipal,Tabora",
  "Imalamakoye,Urambo,Tabora",
  "Itundu (Utundu),Urambo,Tabora",
  "Kapilula,Urambo,Tabora",
  "Kasisi,Urambo,Tabora",
  "Kiloleni,Urambo,Tabora",
  "Muungano,Urambo,Tabora",
  "Nsenda,Urambo,Tabora",
  "Songambele,Urambo,Tabora",
  "Ugalla,Urambo,Tabora",
  "Ukondamoyo,Urambo,Tabora",
  "Urambo,Urambo,Tabora",
  "Usisya,Urambo,Tabora",
  "Ussoke,Urambo,Tabora",
  "Uyogo,Urambo,Tabora",
  "Uyumbu,Urambo,Tabora",
  "Vumilia,Urambo,Tabora",
  "Bukumbi,Uyui,Tabora",
  "Goweko,Uyui,Tabora",
  "Ibelamilundi,Uyui,Tabora",
  "Ibiri,Uyui,Tabora",
  "Igalula,Uyui,Tabora",
  "Ikongolo,Uyui,Tabora",
  "Ilolanguru,Uyui,Tabora",
  "Isikizya,Uyui,Tabora",
  "Kigwa,Uyui,Tabora",
  "Kizengi,Uyui,Tabora",
  "Loya,Uyui,Tabora",
  "Lutende,Uyui,Tabora",
  "Mabama,Uyui,Tabora",
  "Magiri,Uyui,Tabora",
  "Miswaki,Uyui,Tabora",
  "Miyenze,Uyui,Tabora",
  "Ndono,Uyui,Tabora",
  "Nsimbo,Uyui,Tabora",
  "Nsololo,Uyui,Tabora",
  "Shitage,Uyui,Tabora",
  "Tura,Uyui,Tabora",
  "Ufulumwa (Ufuluma),Uyui,Tabora",
  "Upuge,Uyui,Tabora",
  "Usagari,Uyui,Tabora",
  "Bwilingu,Bagamoyo,Pwani",
  "Dunda,Bagamoyo,Pwani",
  "Fukayosi (Fukayose),Bagamoyo,Pwani",
  "Kerege,Bagamoyo,Pwani",
  "Kibindu,Bagamoyo,Pwani",
  "Kimange,Bagamoyo,Pwani",
  "Kiromo,Bagamoyo,Pwani",
  "Kiwangwa,Bagamoyo,Pwani",
  "Lugoba,Bagamoyo,Pwani",
  "Magomeni,Bagamoyo,Pwani",
  "Mandera,Bagamoyo,Pwani",
  "Mbwewe,Bagamoyo,Pwani",
  "Miono,Bagamoyo,Pwani",
  "Mkange,Bagamoyo,Pwani",
  "Msata,Bagamoyo,Pwani",
  "Msoga,Bagamoyo,Pwani",
  "Pera,Bagamoyo,Pwani",
  "Talawanda,Bagamoyo,Pwani",
  "Ubenazomozi,Bagamoyo,Pwani",
  "Vigwaza,Bagamoyo,Pwani",
  "Yombo,Bagamoyo,Pwani",
  "Zinga,Bagamoyo,Pwani",
  "Chagongwe,Gairo,Morogoro",
  "Chakwale,Gairo,Morogoro",
  "Chanjale,Gairo,Morogoro",
  "Gairo,Gairo,Morogoro",
  "Idibo,Gairo,Morogoro",
  "Iyogwe,Gairo,Morogoro",
  "Kibedya,Gairo,Morogoro",
  "Mandege,Gairo,Morogoro",
  "Msingisi,Gairo,Morogoro",
  "Nongwe,Gairo,Morogoro",
  "Rubeho,Gairo,Morogoro",
  "Buguruni,Ilala Municipal,Dar es Salaam",
  "Chanika,Ilala Municipal,Dar es Salaam",
  "Gerezani,Ilala Municipal,Dar es Salaam",
  "Gongo la Mboto,Ilala Municipal,Dar es Salaam",
  "Ilala,Ilala Municipal,Dar es Salaam",
  "Jangwani,Ilala Municipal,Dar es Salaam",
  "Kariakoo,Ilala Municipal,Dar es Salaam",
  "Kimanga,Ilala Municipal,Dar es Salaam",
  "Kinyerezi,Ilala Municipal,Dar es Salaam",
  "Kipawa,Ilala Municipal,Dar es Salaam",
  "Kisutu,Ilala Municipal,Dar es Salaam",
  "Kitunda,Ilala Municipal,Dar es Salaam",
  "Kivukoni,Ilala Municipal,Dar es Salaam",
  "Kivule,Ilala Municipal,Dar es Salaam",
  "Kiwalani,Ilala Municipal,Dar es Salaam",
  "Majohe,Ilala Municipal,Dar es Salaam",
  "Mchafukoge,Ilala Municipal,Dar es Salaam",
  "Mchikichini,Ilala Municipal,Dar es Salaam",
  "Msongola,Ilala Municipal,Dar es Salaam",
  "Pugu,Ilala Municipal,Dar es Salaam",
  "Segerea,Ilala Municipal,Dar es Salaam",
  "Tabata,Ilala Municipal,Dar es Salaam",
  "Ukonga,Ilala Municipal,Dar es Salaam",
  "Upanga Magharibi,Ilala Municipal,Dar es Salaam",
  "Upanga Mashariki,Ilala Municipal,Dar es Salaam",
  "Vingunguti,Ilala Municipal,Dar es Salaam",
  "Bokomnemela,Kibaha,Pwani",
  "Dutumi,Kibaha,Pwani",
  "Gwata,Kibaha,Pwani",
  "Janga,Kibaha,Pwani",
  "Kikongo,Kibaha,Pwani",
  "Kilangalanga,Kibaha,Pwani",
  "Kwala,Kibaha,Pwani",
  "Magindu,Kibaha,Pwani",
  "Mlandizi,Kibaha,Pwani",
  "Ruvu,Kibaha,Pwani",
  "Soga,Kibaha,Pwani",
  "Kibaha Town,Kibaha,Pwani",
  "Kibaha,Kibaha,Pwani",
  "Kongowe,Kibaha,Pwani",
  "Maili Moja,Kibaha,Pwani",
  "Mbwawa,Kibaha,Pwani",
  "Misugusugu,Kibaha,Pwani",
  "Mkuza,Kibaha,Pwani",
  "Msangani,Kibaha,Pwani",
  "Pangani,Kibaha,Pwani",
  "Picha ya Ndege,Kibaha,Pwani",
  "Tumbi,Kibaha,Pwani",
  "Visiga,Kibaha,Pwani",
  "Chisano,Kilombero,Morogoro",
  "Chita,Kilombero,Morogoro",
  "Idete,Kilombero,Morogoro",
  "Ifakara,Kilombero,Morogoro",
  "Kibaoni,Kilombero,Morogoro",
  "Kiberege,Kilombero,Morogoro",
  "Kidatu,Kilombero,Morogoro",
  "Kisawasawa,Kilombero,Morogoro",
  "Lumemo,Kilombero,Morogoro",
  "Mang'ula,Kilombero,Morogoro",
  "Masagati,Kilombero,Morogoro",
  "Mbingu,Kilombero,Morogoro",
  "Mchombe,Kilombero,Morogoro",
  "Mkula,Kilombero,Morogoro",
  "Mlimba,Kilombero,Morogoro",
  "Mofu,Kilombero,Morogoro",
  "Sanje,Kilombero,Morogoro",
  "Uchindile,Kilombero,Morogoro",
  "Utengule,Kilombero,Morogoro",
  "Berega,Kilosa,Morogoro",
  "Chanzulu,Kilosa,Morogoro",
  "Dumila,Kilosa,Morogoro",
  "Kasiki,Kilosa,Morogoro",
  "Kidete,Kilosa,Morogoro",
  "Kidodi,Kilosa,Morogoro",
  "Kilangali,Kilosa,Morogoro",
  "Kimamba A,Kilosa,Morogoro",
  "Kimamba B,Kilosa,Morogoro",
  "Kisanga,Kilosa,Morogoro",
  "Kitete,Kilosa,Morogoro",
  "Lumbiji,Kilosa,Morogoro",
  "Lumuma,Kilosa,Morogoro",
  "Mabula,Kilosa,Morogoro",
  "Mabwerebwere,Kilosa,Morogoro",
  "Madoto,Kilosa,Morogoro",
  "Magole,Kilosa,Morogoro",
  "Magomeni,Kilosa,Morogoro",
  "Magubike,Kilosa,Morogoro",
  "Maguha,Kilosa,Morogoro",
  "Malolo,Kilosa,Morogoro",
  "Mamboya,Kilosa,Morogoro",
  "Masanze,Kilosa,Morogoro",
  "Mbumi,Kilosa,Morogoro",
  "Mikumi,Kilosa,Morogoro",
  "Mkwatani,Kilosa,Morogoro",
  "Msowero,Kilosa,Morogoro",
  "Ruaha,Kilosa,Morogoro",
  "Rudewa,Kilosa,Morogoro",
  "Ruhembe,Kilosa,Morogoro",
  "Tindiga,Kilosa,Morogoro",
  "Ulaya,Kilosa,Morogoro",
  "Uleling'ombe,Kilosa,Morogoro",
  "Vidunda,Kilosa,Morogoro",
  "Zombo,Kilosa,Morogoro",
  "Chumo,Kilwa,Lindi",
  "Kandawale,Kilwa,Lindi",
  "Kibata,Kilwa,Lindi",
  "Kikole,Kilwa,Lindi",
  "Kinjumbi,Kilwa,Lindi",
  "Kipatimu,Kilwa,Lindi",
  "Kiranjeranje (Kirnjernje),Kilwa,Lindi",
  "Kivinjesingino,Kilwa,Lindi",
  "Lihimalyao,Kilwa,Lindi",
  "Likawage,Kilwa,Lindi",
  "Mandawa,Kilwa,Lindi",
  "Masoko,Kilwa,Lindi",
  "Miguruwe,Kilwa,Lindi",
  "Mingumbi,Kilwa,Lindi",
  "Miteja,Kilwa,Lindi",
  "Mitole,Kilwa,Lindi",
  "Nanjirinji,Kilwa,Lindi",
  "Njinjo,Kilwa,Lindi",
  "Pande Mikoma,Kilwa,Lindi",
  "Songosongo,Kilwa,Lindi",
  "Tingi,Kilwa,Lindi",
  "Bunju,Kinondoni Municipal,Dar es Salaam",
  "Goba,Kinondoni Municipal,Dar es Salaam",
  "Hananasif (Hananasifu),Kinondoni Municipal,Dar es Salaam",
  "Kawe,Kinondoni Municipal,Dar es Salaam",
  "Kibamba,Kinondoni Municipal,Dar es Salaam",
  "Kigogo,Kinondoni Municipal,Dar es Salaam",
  "Kijitonyama,Kinondoni Municipal,Dar es Salaam",
  "Kimara,Kinondoni Municipal,Dar es Salaam",
  "Kinondoni,Kinondoni Municipal,Dar es Salaam",
  "Kunduchi,Kinondoni Municipal,Dar es Salaam",
  "Kwembe,Kinondoni Municipal,Dar es Salaam",
  "Mabibo,Kinondoni Municipal,Dar es Salaam",
  "Mabwepande,Kinondoni Municipal,Dar es Salaam",
  "Magomeni,Kinondoni Municipal,Dar es Salaam",
  "Makongo,Kinondoni Municipal,Dar es Salaam",
  "Makuburi,Kinondoni Municipal,Dar es Salaam",
  "Makumbusho,Kinondoni Municipal,Dar es Salaam",
  "Makurumla,Kinondoni Municipal,Dar es Salaam",
  "Manzese,Kinondoni Municipal,Dar es Salaam",
  "Mbezi,Kinondoni Municipal,Dar es Salaam",
  "Mbezi juu,Kinondoni Municipal,Dar es Salaam",
  "Mburahati,Kinondoni Municipal,Dar es Salaam",
  "Mbweni,Kinondoni Municipal,Dar es Salaam",
  "Mikocheni,Kinondoni Municipal,Dar es Salaam",
  "Msasani,Kinondoni Municipal,Dar es Salaam",
  "Msigani,Kinondoni Municipal,Dar es Salaam",
  "Mwananyamala,Kinondoni Municipal,Dar es Salaam",
  "Mzimuni,Kinondoni Municipal,Dar es Salaam",
  "Ndugumbi,Kinondoni Municipal,Dar es Salaam",
  "Saranga,Kinondoni Municipal,Dar es Salaam",
  "Sinza,Kinondoni Municipal,Dar es Salaam",
  "Tandale,Kinondoni Municipal,Dar es Salaam",
  "Ubungo,Kinondoni Municipal,Dar es Salaam",
  "Wazo,Kinondoni Municipal,Dar es Salaam",
  "Cholesamvula,Kisarawe,Pwani",
  "Kibuta,Kisarawe,Pwani",
  "Kiluvya,Kisarawe,Pwani",
  "Kisarawe,Kisarawe,Pwani",
  "Kurui,Kisarawe,Pwani",
  "Mafizi,Kisarawe,Pwani",
  "Maneromango,Kisarawe,Pwani",
  "Marui,Kisarawe,Pwani",
  "Marumbo,Kisarawe,Pwani",
  "Masaki,Kisarawe,Pwani",
  "Msanga,Kisarawe,Pwani",
  "Msimbu,Kisarawe,Pwani",
  "Mzenga,Kisarawe,Pwani",
  "Vihingo,Kisarawe,Pwani",
  "Vikumbulu,Kisarawe,Pwani",
  "Chikonji,Lindi Municipal,Lindi",
  "Jamhuri,Lindi Municipal,Lindi",
  "Makonde,Lindi Municipal,Lindi",
  "Matopeni,Lindi Municipal,Lindi",
  "Mbanja,Lindi Municipal,Lindi",
  "Mikumbi,Lindi Municipal,Lindi",
  "Mingoyo,Lindi Municipal,Lindi",
  "Mitandi,Lindi Municipal,Lindi",
  "Msanjihili (Msinjahili),Lindi Municipal,Lindi",
  "Mtanda,Lindi Municipal,Lindi",
  "Mwenge,Lindi Municipal,Lindi",
  "Nachingwea,Lindi Municipal,Lindi",
  "Ndoro,Lindi Municipal,Lindi",
  "Ng'apa,Lindi Municipal,Lindi",
  "Rahaleo,Lindi Municipal,Lindi",
  "Rasbura,Lindi Municipal,Lindi",
  "Tandangongoro,Lindi Municipal,Lindi",
  "Wailes,Lindi Municipal,Lindi",
  "Barikiwa,Liwale,Lindi",
  "Kiangara,Liwale,Lindi",
  "Kibutuka,Liwale,Lindi",
  "Kichonda,Liwale,Lindi",
  "Kimambi,Liwale,Lindi",
  "Likongowele,Liwale,Lindi",
  "Lilombe,Liwale,Lindi",
  "Liwale 'B',Liwale,Lindi",
  "Liwale Mjini,Liwale,Lindi",
  "Makata,Liwale,Lindi",
  "Mangirirkiti (Mangirikiti),Liwale,Lindi",
  "Mbaya,Liwale,Lindi",
  "Mihumo,Liwale,Lindi",
  "Mirui,Liwale,Lindi",
  "Mkutano,Liwale,Lindi",
  "Mlembwe,Liwale,Lindi",
  "Mpigamiti,Liwale,Lindi",
  "Nangando,Liwale,Lindi",
  "Nangano,Liwale,Lindi",
  "Ngongowele,Liwale,Lindi",
  "Baleni,Mafia,Pwani",
  "Jibondo,Mafia,Pwani",
  "Kanga,Mafia,Pwani",
  "Kiegeani,Mafia,Pwani",
  "Kilindoni,Mafia,Pwani",
  "Kirongwe,Mafia,Pwani",
  "Miburani,Mafia,Pwani",
  "Ndagoni,Mafia,Pwani",
  "Bupu,Mkuranga,Pwani",
  "Kimanzichana,Mkuranga,Pwani",
  "Kiparang'anda,Mkuranga,Pwani",
  "Kisiju,Mkuranga,Pwani",
  "Kitomondo,Mkuranga,Pwani",
  "Lukanga,Mkuranga,Pwani",
  "Magawa,Mkuranga,Pwani",
  "Mbezi,Mkuranga,Pwani",
  "Mkamba,Mkuranga,Pwani",
  "Mkuranga,Mkuranga,Pwani",
  "Mwalusembe (Mwarusembe),Mkuranga,Pwani",
  "Njia Nne,Mkuranga,Pwani",
  "Nyamato,Mkuranga,Pwani",
  "Panzuo,Mkuranga,Pwani",
  "Shungubweni,Mkuranga,Pwani",
  "Tambani,Mkuranga,Pwani",
  "Vianzi,Mkuranga,Pwani",
  "Vikindu,Mkuranga,Pwani",
  "Bigwa,Morogoro Municipal,Morogoro",
  "Boma,Morogoro Municipal,Morogoro",
  "Kichangani,Morogoro Municipal,Morogoro",
  "Kihonda,Morogoro Municipal,Morogoro",
  "Kilakala,Morogoro Municipal,Morogoro",
  "Kingo,Morogoro Municipal,Morogoro",
  "Kingolwira,Morogoro Municipal,Morogoro",
  "Kiwanja cha Ndege,Morogoro Municipal,Morogoro",
  "Mafiga,Morogoro Municipal,Morogoro",
  "Mazimbu,Morogoro Municipal,Morogoro",
  "Mbuyuni,Morogoro Municipal,Morogoro",
  "Mji Mkuu,Morogoro Municipal,Morogoro",
  "Mji Mpya,Morogoro Municipal,Morogoro",
  "Mlimani,Morogoro Municipal,Morogoro",
  "Mwembesongo,Morogoro Municipal,Morogoro",
  "Mzinga,Morogoro Municipal,Morogoro",
  "Sabasaba,Morogoro Municipal,Morogoro",
  "Sultan Area,Morogoro Municipal,Morogoro",
  "Uwanja wa Taifa,Morogoro Municipal,Morogoro",
  "Chikongola,Mtwara Municipal,Mtwara",
  "Chuno,Mtwara Municipal,Mtwara",
  "Jangwani,Mtwara Municipal,Mtwara",
  "Kisungule,Mtwara Municipal,Mtwara",
  "Likombe,Mtwara Municipal,Mtwara",
  "Magengeni,Mtwara Municipal,Mtwara",
  "Majengo,Mtwara Municipal,Mtwara",
  "Mitengo,Mtwara Municipal,Mtwara",
  "Mtonya,Mtwara Municipal,Mtwara",
  "Naliendele,Mtwara Municipal,Mtwara",
  "Rahaleo,Mtwara Municipal,Mtwara",
  "Railway,Mtwara Municipal,Mtwara",
  "Shangani,Mtwara Municipal,Mtwara",
  "Ufukoni,Mtwara Municipal,Mtwara",
  "Vigaeni,Mtwara Municipal,Mtwara",
  "Bunduki,Mvomero,Morogoro",
  "Diongoya,Mvomero,Morogoro",
  "Doma,Mvomero,Morogoro",
  "Hembeti,Mvomero,Morogoro",
  "Kanga,Mvomero,Morogoro",
  "Kibati,Mvomero,Morogoro",
  "Kikeo,Mvomero,Morogoro",
  "Langali,Mvomero,Morogoro",
  "Maskati,Mvomero,Morogoro",
  "Melela,Mvomero,Morogoro",
  "Mhonda,Mvomero,Morogoro",
  "Mlali,Mvomero,Morogoro",
  "Mtibwa,Mvomero,Morogoro",
  "Mvomero,Mvomero,Morogoro",
  "Mzumbe,Mvomero,Morogoro",
  "Sungaji,Mvomero,Morogoro",
  "Tchenzema,Mvomero,Morogoro",
  "Chiola,Nachingwea,Lindi",
  "Kiegei,Nachingwea,Lindi",
  "Kilimahewa (Kilimanihewa),Nachingwea,Lindi",
  "Kilimarondo,Nachingwea,Lindi",
  "Kipara Mnero,Nachingwea,Lindi",
  "Lionja,Nachingwea,Lindi",
  "Marambo,Nachingwea,Lindi",
  "Matekwe,Nachingwea,Lindi",
  "Mbondo,Nachingwea,Lindi",
  "Mkoka,Nachingwea,Lindi",
  "Mkotokuyana,Nachingwea,Lindi",
  "Mnero Miembeni,Nachingwea,Lindi",
  "Mnerongongo (Minerongongo),Nachingwea,Lindi",
  "Mpiruka,Nachingwea,Lindi",
  "Mtua,Nachingwea,Lindi",
  "Naipanga,Nachingwea,Lindi",
  "Naipingo,Nachingwea,Lindi",
  "Namapwia,Nachingwea,Lindi",
  "Namatula,Nachingwea,Lindi",
  "Nambambo,Nachingwea,Lindi",
  "Namikango,Nachingwea,Lindi",
  "Nangowe,Nachingwea,Lindi",
  "Nditi,Nachingwea,Lindi",
  "Ndomoni,Nachingwea,Lindi",
  "Ruponda,Nachingwea,Lindi",
  "Stesheni,Nachingwea,Lindi",
  "Chipuputa,Nanyumbu,Mtwara",
  "Likokona,Nanyumbu,Mtwara",
  "Lumesule,Nanyumbu,Mtwara",
  "Mangaka,Nanyumbu,Mtwara",
  "Maratani,Nanyumbu,Mtwara",
  "Masuguru,Nanyumbu,Mtwara",
  "Mikangaula,Nanyumbu,Mtwara",
  "Mkonona,Nanyumbu,Mtwara",
  "Mnanje,Nanyumbu,Mtwara",
  "Nandete,Nanyumbu,Mtwara",
  "Nangomba,Nanyumbu,Mtwara",
  "Nanyumbu,Nanyumbu,Mtwara",
  "Napacho,Nanyumbu,Mtwara",
  "Sengenya,Nanyumbu,Mtwara",
  "Chihangu,Newala,Mtwara",
  "Chilangalanga (Chilangala),Newala,Mtwara",
  "Chitekete,Newala,Mtwara",
  "Chiwonga,Newala,Mtwara",
  "Kitangari,Newala,Mtwara",
  "Luchingu (Luchindu),Newala,Mtwara",
  "Makonga,Newala,Mtwara",
  "Makote,Newala,Mtwara",
  "Makukwe,Newala,Mtwara",
  "Malatu,Newala,Mtwara",
  "Maputi,Newala,Mtwara",
  "Mchemo,Newala,Mtwara",
  "Mcholi I,Newala,Mtwara",
  "Mcholi II,Newala,Mtwara",
  "Mdimbampelempele,Newala,Mtwara",
  "Mkoma II,Newala,Mtwara",
  "Mkunya,Newala,Mtwara",
  "Mkwedu,Newala,Mtwara",
  "Mnekachi,Newala,Mtwara",
  "Mnyambe,Newala,Mtwara",
  "Mtonya,Newala,Mtwara",
  "Mtopwa,Newala,Mtwara",
  "Mtunguru,Newala,Mtwara",
  "Nakahako,Newala,Mtwara",
  "Nambali,Newala,Mtwara",
  "Namiyonga,Newala,Mtwara",
  "Nandwahi,Newala,Mtwara",
  "Nanguruwe,Newala,Mtwara",
  "Chibula,Ruangwa,Lindi",
  "Chienjele,Ruangwa,Lindi",
  "Chinongwe,Ruangwa,Lindi",
  "Chunyu,Ruangwa,Lindi",
  "Likunja,Ruangwa,Lindi",
  "Luchelegwa,Ruangwa,Lindi",
  "Makanjiro,Ruangwa,Lindi",
  "Malolo,Ruangwa,Lindi",
  "Mandarawe,Ruangwa,Lindi",
  "Mandawa,Ruangwa,Lindi",
  "Matambarale,Ruangwa,Lindi",
  "Mbekenyera,Ruangwa,Lindi",
  "Mnacho,Ruangwa,Lindi",
  "Nachingwea,Ruangwa,Lindi",
  "Nambilaje (Nambilanje),Ruangwa,Lindi",
  "Namichiga,Ruangwa,Lindi",
  "Nandagala,Ruangwa,Lindi",
  "Nanganga,Ruangwa,Lindi",
  "Narung'ombe,Ruangwa,Lindi",
  "Nkowe,Ruangwa,Lindi",
  "Ruangwa,Ruangwa,Lindi",
  "Bungu,Rufiji,Pwani",
  "Chemchem,Rufiji,Pwani",
  "Chumbi,Rufiji,Pwani",
  "Dimani,Rufiji,Pwani",
  "Ikwiriri,Rufiji,Pwani",
  "Kibiti,Rufiji,Pwani",
  "Kiongoroni,Rufiji,Pwani",
  "Mahege,Rufiji,Pwani",
  "Maparoni,Rufiji,Pwani",
  "Mbuchi,Rufiji,Pwani",
  "Mbwara,Rufiji,Pwani",
  "Mchukwi,Rufiji,Pwani",
  "Mgomba,Rufiji,Pwani",
  "Mjawa,Rufiji,Pwani",
  "Mkongo,Rufiji,Pwani",
  "Mlanzi,Rufiji,Pwani",
  "Mtawanya,Rufiji,Pwani",
  "Mtunda,Rufiji,Pwani",
  "Mwambao,Rufiji,Pwani",
  "Mwaseni,Rufiji,Pwani",
  "Ngarambe,Rufiji,Pwani",
  "Ngorongo,Rufiji,Pwani",
  "Ruaruke,Rufiji,Pwani",
  "Salale,Rufiji,Pwani",
  "Umwe,Rufiji,Pwani",
  "Utete,Rufiji,Pwani",
  "Chaume,Tandahimba,Mtwara",
  "Chikongola,Tandahimba,Mtwara",
  "Chingungwe,Tandahimba,Mtwara",
  "Dinduma,Tandahimba,Mtwara",
  "Kitama,Tandahimba,Mtwara",
  "Kwanyama,Tandahimba,Mtwara",
  "Litehu,Tandahimba,Mtwara",
  "Luagala,Tandahimba,Mtwara",
  "Lukokoda,Tandahimba,Mtwara",
  "Lyenje,Tandahimba,Mtwara",
  "Mahuta,Tandahimba,Mtwara",
  "Maundo,Tandahimba,Mtwara",
  "Mchichira,Tandahimba,Mtwara",
  "Mdimbamnyoma,Tandahimba,Mtwara",
  "Mdumbwe,Tandahimba,Mtwara",
  "Michenjele,Tandahimba,Mtwara",
  "Mihambwe,Tandahimba,Mtwara",
  "Mihuta (Miuta),Tandahimba,Mtwara",
  "Milingodi (Milongodi),Tandahimba,Mtwara",
  "Mkonjowano,Tandahimba,Mtwara",
  "Mkoreha,Tandahimba,Mtwara",
  "Mkundi,Tandahimba,Mtwara",
  "Mkwiti,Tandahimba,Mtwara",
  "Mnyawa,Tandahimba,Mtwara",
  "Nambahu,Tandahimba,Mtwara",
  "Namikupa,Tandahimba,Mtwara",
  "Nanhyanga,Tandahimba,Mtwara",
  "Naputa,Tandahimba,Mtwara",
  "Ngunja,Tandahimba,Mtwara",
  "Tandahimba,Tandahimba,Mtwara",
  "Azimio,Temeke Municipal,Dar es Salaam",
  "Buza,Temeke Municipal,Dar es Salaam",
  "Chamazi,Temeke Municipal,Dar es Salaam",
  "Chang'ombe,Temeke Municipal,Dar es Salaam",
  "Charambe,Temeke Municipal,Dar es Salaam",
  "Keko,Temeke Municipal,Dar es Salaam",
  "Kibada,Temeke Municipal,Dar es Salaam",
  "Kiburugwa,Temeke Municipal,Dar es Salaam",
  "Kigamboni,Temeke Municipal,Dar es Salaam",
  "Kijichi,Temeke Municipal,Dar es Salaam",
  "Kilakala,Temeke Municipal,Dar es Salaam",
  "Kimbiji,Temeke Municipal,Dar es Salaam",
  "Kisarawe II,Temeke Municipal,Dar es Salaam",
  "Kurasini,Temeke Municipal,Dar es Salaam",
  "Makangarawe,Temeke Municipal,Dar es Salaam",
  "Mbagala,Temeke Municipal,Dar es Salaam",
  "Mbagala Kuu,Temeke Municipal,Dar es Salaam",
  "Mianzini,Temeke Municipal,Dar es Salaam",
  "Miburani,Temeke Municipal,Dar es Salaam",
  "Mjimwema,Temeke Municipal,Dar es Salaam",
  "Mtoni,Temeke Municipal,Dar es Salaam",
  "Pemba Mnazi,Temeke Municipal,Dar es Salaam",
  "Sandali,Temeke Municipal,Dar es Salaam",
  "Somangila,Temeke Municipal,Dar es Salaam",
  "Tandika,Temeke Municipal,Dar es Salaam",
  "Temeke,Temeke Municipal,Dar es Salaam",
  "Toangoma,Temeke Municipal,Dar es Salaam",
  "Tungi,Temeke Municipal,Dar es Salaam",
  "Vijibweni,Temeke Municipal,Dar es Salaam",
  "Yombo Vituka,Temeke Municipal,Dar es Salaam",
  "Biro,Ulanga,Morogoro",
  "Chirombola,Ulanga,Morogoro",
  "Euga,Ulanga,Morogoro",
  "Ilonga,Ulanga,Morogoro",
  "Iragua,Ulanga,Morogoro",
  "Isongo,Ulanga,Morogoro",
  "Itete,Ulanga,Morogoro",
  "Kichangani,Ulanga,Morogoro",
  "Kilosa kwa Mpepo,Ulanga,Morogoro",
  "Lukande,Ulanga,Morogoro",
  "Lupiro,Ulanga,Morogoro",
  "Mahenge,Ulanga,Morogoro",
  "Malinyi,Ulanga,Morogoro",
  "Mbuga,Ulanga,Morogoro",
  "Minepa,Ulanga,Morogoro",
  "Msogezi,Ulanga,Morogoro",
  "Mtimbira,Ulanga,Morogoro",
  "Mwaya,Ulanga,Morogoro",
  "Ngoheranga,Ulanga,Morogoro",
  "Ruaha,Ulanga,Morogoro",
  "Sali,Ulanga,Morogoro",
  "Sofi,Ulanga,Morogoro",
  "Usangule,Ulanga,Morogoro",
  "Vigoi,Ulanga,Morogoro",
  "Bariadi,Bariadi,Simiyu",
  "Bunamhala,Bariadi,Simiyu",
  "Dutwa,Bariadi,Simiyu",
  "Gambosi,Bariadi,Simiyu",
  "Gilya,Bariadi,Simiyu",
  "Guduwi,Bariadi,Simiyu",
  "Ikungulyabashashi,Bariadi,Simiyu",
  "Isanga,Bariadi,Simiyu",
  "Kasoli,Bariadi,Simiyu",
  "Kilalo,Bariadi,Simiyu",
  "Malambo,Bariadi,Simiyu",
  "Matongo,Bariadi,Simiyu",
  "Mhango,Bariadi,Simiyu",
  "Mwadobana (Madobana),Bariadi,Simiyu",
  "Mwaubingi (Mwaubinge),Bariadi,Simiyu",
  "Mwaumatondo,Bariadi,Simiyu",
  "Ngulyati,Bariadi,Simiyu",
  "Nkindwabiye,Bariadi,Simiyu",
  "Nkololo,Bariadi,Simiyu",
  "Nyakabindi,Bariadi,Simiyu",
  "Nyangokolwa,Bariadi,Simiyu",
  "Sakwe,Bariadi,Simiyu",
  "Sapiwi,Bariadi,Simiyu",
  "Sima,Bariadi,Simiyu",
  "Somanda,Bariadi,Simiyu",
  "Biharamulo Mjini,Biharamulo,Kagera",
  "Bisibo,Biharamulo,Kagera",
  "Kabindi,Biharamulo,Kagera",
  "Kalenge,Biharamulo,Kagera",
  "Kaniha,Biharamulo,Kagera",
  "Lusahunga,Biharamulo,Kagera",
  "Nemba,Biharamulo,Kagera",
  "Nyabusozi,Biharamulo,Kagera",
  "Nyakahura,Biharamulo,Kagera",
  "Nyamahanga,Biharamulo,Kagera",
  "Nyamigogo,Biharamulo,Kagera",
  "Nyantakara,Biharamulo,Kagera",
  "Nyarubungo,Biharamulo,Kagera",
  "Runazi,Biharamulo,Kagera",
  "Ruziba,Biharamulo,Kagera",
  "Biharu,Buhigwe,Kigoma",
  "Buhigwe,Buhigwe,Kigoma",
  "Janda,Buhigwe,Kigoma",
  "Kajana,Buhigwe,Kigoma",
  "Kibande,Buhigwe,Kigoma",
  "Kilelema,Buhigwe,Kigoma",
  "Mugera,Buhigwe,Kigoma",
  "Muhinda,Buhigwe,Kigoma",
  "Munanila,Buhigwe,Kigoma",
  "Munyegera,Buhigwe,Kigoma",
  "Munzeze,Buhigwe,Kigoma",
  "Muyama,Buhigwe,Kigoma",
  "Mwayaya,Buhigwe,Kigoma",
  "Nyamugali,Buhigwe,Kigoma",
  "Rusaba,Buhigwe,Kigoma",
  "Bakoba,Bukoba Municipal,Kagera",
  "Bilele,Bukoba Municipal,Kagera",
  "Buhembe (Buhemba),Bukoba Municipal,Kagera",
  "Hamugembe,Bukoba Municipal,Kagera",
  "Ijuganyondo,Bukoba Municipal,Kagera",
  "Kagondo,Bukoba Municipal,Kagera",
  "Kahororo,Bukoba Municipal,Kagera",
  "Kashai,Bukoba Municipal,Kagera",
  "Kibeta,Bukoba Municipal,Kagera",
  "Kitendaguro,Bukoba Municipal,Kagera",
  "Miembeni,Bukoba Municipal,Kagera",
  "Nshambya,Bukoba Municipal,Kagera",
  "Nyanga,Bukoba Municipal,Kagera",
  "Rwamishenye,Bukoba Municipal,Kagera",
  "Bugelenga,Bukombe,Geita",
  "Bukombe,Bukombe,Geita",
  "Busonzo,Bukombe,Geita",
  "Butinzya,Bukombe,Geita",
  "Igulwa,Bukombe,Geita",
  "Iyogelo,Bukombe,Geita",
  "Lyambamgongo,Bukombe,Geita",
  "Namonge,Bukombe,Geita",
  "Ng'anzo,Bukombe,Geita",
  "Runzewe Magharibi,Bukombe,Geita",
  "Runzewe Mashariki,Bukombe,Geita",
  "Ushirombo,Bukombe,Geita",
  "Uyovu,Bukombe,Geita",
  "Balili,Bunda,Mara",
  "Bunda Mjini,Bunda,Mara",
  "Bunda Stoo,Bunda,Mara",
  "Butimba,Bunda,Mara",
  "Chitengule,Bunda,Mara",
  "Guta,Bunda,Mara",
  "Hunyari,Bunda,Mara",
  "Igundu,Bunda,Mara",
  "Iramba,Bunda,Mara",
  "Kabasa,Bunda,Mara",
  "Kasuguti,Bunda,Mara",
  "Ketare,Bunda,Mara",
  "Kibara,Bunda,Mara",
  "Kisorya,Bunda,Mara",
  "Kunzugu,Bunda,Mara",
  "Mcharo,Bunda,Mara",
  "Mihingo,Bunda,Mara",
  "Mugeta,Bunda,Mara",
  "Namhula,Bunda,Mara",
  "Nampindi,Bunda,Mara",
  "Nansimo,Bunda,Mara",
  "Neruma,Bunda,Mara",
  "Nyamang'uta,Bunda,Mara",
  "Nyamuswa,Bunda,Mara",
  "Nyasura,Bunda,Mara",
  "Salama,Bunda,Mara",
  "Sazira,Bunda,Mara",
  "Wariku,Bunda,Mara",
  "Badugu,Busega,Simiyu",
  "Igalukilo,Busega,Simiyu",
  "Kabita,Busega,Simiyu",
  "Kalemela,Busega,Simiyu",
  "Kiloleli,Busega,Simiyu",
  "Lamadi,Busega,Simiyu",
  "Lutubiga,Busega,Simiyu",
  "Malili,Busega,Simiyu",
  "Mkula,Busega,Simiyu",
  "Mwamanyili,Busega,Simiyu",
  "Ngasamo,Busega,Simiyu",
  "Nyaluhande,Busega,Simiyu",
  "Shigala,Busega,Simiyu",
  "Bisumwa,Butiama,Mara",
  "Buhemba,Butiama,Mara",
  "Bukabwa,Butiama,Mara",
  "Buruma,Butiama,Mara",
  "Busegwe,Butiama,Mara",
  "Buswahili,Butiama,Mara",
  "Butiama,Butiama,Mara",
  "Butuguri,Butiama,Mara",
  "Bwiregi,Butiama,Mara",
  "Etaro,Butiama,Mara",
  "Kukirango,Butiama,Mara",
  "Kyanyari,Butiama,Mara",
  "Masaba,Butiama,Mara",
  "Mirwa,Butiama,Mara",
  "Muriaza,Butiama,Mara",
  "Nyakatende,Butiama,Mara",
  "Nyamimange,Butiama,Mara",
  "Nyankanga,Butiama,Mara",
  "Nyegina,Butiama,Mara",
  "Sirorisimba,Butiama,Mara",
  "Bukome,Chato,Geita",
  "Buseresere,Chato,Geita",
  "Butengorumasa,Chato,Geita",
  "Buziku,Chato,Geita",
  "Bwanga,Chato,Geita",
  "Bwera,Chato,Geita",
  "Bwina,Chato,Geita",
  "Bwongera,Chato,Geita",
  "Chato,Chato,Geita",
  "Ichwankima,Chato,Geita",
  "Ilemela,Chato,Geita",
  "Ilyamchele,Chato,Geita",
  "Iparamasa,Chato,Geita",
  "Kachwamba,Chato,Geita",
  "Kasenga,Chato,Geita",
  "Katende,Chato,Geita",
  "Kigongo,Chato,Geita",
  "Makurugusi,Chato,Geita",
  "Muganza,Chato,Geita",
  "Muungano,Chato,Geita",
  "Nyamirembe,Chato,Geita",
  "Nyarutembo,Chato,Geita",
  "Bugogwa,Ilemela Municipal,Mwanza",
  "Buswelu,Ilemela Municipal,Mwanza",
  "Ilemela,Ilemela Municipal,Mwanza",
  "Kirumba,Ilemela Municipal,Mwanza",
  "Kitangiri,Ilemela Municipal,Mwanza",
  "Nyakato,Ilemela Municipal,Mwanza",
  "Nyamanoro,Ilemela Municipal,Mwanza",
  "Pasiansi,Ilemela Municipal,Mwanza",
  "Sangabuye,Ilemela Municipal,Mwanza",
  "Budalabujiga,Itilima,Simiyu",
  "Bumera,Itilima,Simiyu",
  "Chinamili,Itilima,Simiyu",
  "Ikindilo (Ikindiro),Itilima,Simiyu",
  "Kinang'weli,Itilima,Simiyu",
  "Lagangabilili,Itilima,Simiyu",
  "Lugulu,Itilima,Simiyu",
  "Mbita,Itilima,Simiyu",
  "Mhunze,Itilima,Simiyu",
  "Migato,Itilima,Simiyu",
  "Mwalushu,Itilima,Simiyu",
  "Mwamapalala,Itilima,Simiyu",
  "Mwamtani,Itilima,Simiyu",
  "Mwaswale,Itilima,Simiyu",
  "Ndolelezi,Itilima,Simiyu",
  "Nhobora,Itilima,Simiyu",
  "Nkoma,Itilima,Simiyu",
  "Nkuyu,Itilima,Simiyu",
  "Nyamalapa,Itilima,Simiyu",
  "Sagata,Itilima,Simiyu",
  "Sawida,Itilima,Simiyu",
  "Zagayu,Itilima,Simiyu",
  "Gwanumpu (Gwamumpu),Kakonko,Kigoma",
  "Kakonko,Kakonko,Kigoma",
  "Kasanda,Kakonko,Kigoma",
  "Kasuga (Kasunga),Kakonko,Kigoma",
  "Katanga,Kakonko,Kigoma",
  "Kiziguzigu,Kakonko,Kigoma",
  "Mugunzu,Kakonko,Kigoma",
  "Muhange,Kakonko,Kigoma",
  "Nyabibuye,Kakonko,Kigoma",
  "Nyamtukuza,Kakonko,Kigoma",
  "Rugenge,Kakonko,Kigoma",
  "Bugene,Karagwe,Kagera",
  "Bweranyange,Karagwe,Kagera",
  "Chanika,Karagwe,Kagera",
  "Chonyonyo,Karagwe,Kagera",
  "Igurwa,Karagwe,Kagera",
  "Ihanda,Karagwe,Kagera",
  "Ihembe,Karagwe,Kagera",
  "Kanoni,Karagwe,Kagera",
  "Kayanga,Karagwe,Kagera",
  "Kibondo,Karagwe,Kagera",
  "Kihanga,Karagwe,Kagera",
  "Kiruruma,Karagwe,Kagera",
  "Kituntu,Karagwe,Kagera",
  "Ndama,Karagwe,Kagera",
  "Nyabiyonza,Karagwe,Kagera",
  "Nyaishozi,Karagwe,Kagera",
  "Nyakabanga,Karagwe,Kagera",
  "Nyakahanga,Karagwe,Kagera",
  "Nyakakika,Karagwe,Kagera",
  "Nyakasimbi,Karagwe,Kagera",
  "Rugera,Karagwe,Kagera",
  "Rugu,Karagwe,Kagera",
  "Bitare,Kibondo,Kigoma",
  "Bunyanbo (Bunyambo),Kibondo,Kigoma",
  "Busagara,Kibondo,Kigoma",
  "Busunzu,Kibondo,Kigoma",
  "Itaba,Kibondo,Kigoma",
  "Kibondo,Kibondo,Kigoma",
  "Kitahana,Kibondo,Kigoma",
  "Kizazi,Kibondo,Kigoma",
  "Kumsenga,Kibondo,Kigoma",
  "Mabamba,Kibondo,Kigoma",
  "Misezero,Kibondo,Kigoma",
  "Murungu,Kibondo,Kigoma",
  "Rugongwe,Kibondo,Kigoma",
  "Bangwe,Kigoma-Ujiji Municipal,Kigoma",
  "Buhanda,Kigoma-Ujiji Municipal,Kigoma",
  "Businde,Kigoma-Ujiji Municipal,Kigoma",
  "Buzebazeba,Kigoma-Ujiji Municipal,Kigoma",
  "Gungu,Kigoma-Ujiji Municipal,Kigoma",
  "Kagera,Kigoma-Ujiji Municipal,Kigoma",
  "Kasimbu,Kigoma-Ujiji Municipal,Kigoma",
  "Kasingirima,Kigoma-Ujiji Municipal,Kigoma",
  "Katubuka,Kigoma-Ujiji Municipal,Kigoma",
  "Kibirizi,Kigoma-Ujiji Municipal,Kigoma",
  "Kigoma,Kigoma-Ujiji Municipal,Kigoma",
  "Kipampa,Kigoma-Ujiji Municipal,Kigoma",
  "Kitongoni,Kigoma-Ujiji Municipal,Kigoma",
  "Machinjioni,Kigoma-Ujiji Municipal,Kigoma",
  "Majengo,Kigoma-Ujiji Municipal,Kigoma",
  "Mwanga Kaskazini,Kigoma-Ujiji Municipal,Kigoma",
  "Mwanga Kusini,Kigoma-Ujiji Municipal,Kigoma",
  "Rubuga,Kigoma-Ujiji Municipal,Kigoma",
  "Rusimbi,Kigoma-Ujiji Municipal,Kigoma",
  "Bubiki,Kishapu,Shinyanga",
  "Bunambiyu,Kishapu,Shinyanga",
  "Itilima,Kishapu,Shinyanga",
  "Kiloleli,Kishapu,Shinyanga",
  "Kishapu,Kishapu,Shinyanga",
  "Lagana,Kishapu,Shinyanga",
  "Masanga,Kishapu,Shinyanga",
  "Mondo,Kishapu,Shinyanga",
  "Mwadui Luhumbo (Mwadui Lohumbo),Kishapu,Shinyanga",
  "Mwakipoya,Kishapu,Shinyanga",
  "Mwamalasa,Kishapu,Shinyanga",
  "Mwamashele,Kishapu,Shinyanga",
  "Ngofila,Kishapu,Shinyanga",
  "Seke-Bugoro,Kishapu,Shinyanga",
  "Shagihilu,Kishapu,Shinyanga",
  "Somagedi,Kishapu,Shinyanga",
  "Songwa,Kishapu,Shinyanga",
  "Talaga,Kishapu,Shinyanga",
  "Uchunga,Kishapu,Shinyanga",
  "Ukenyenge,Kishapu,Shinyanga",
  "Bugando,Kwimba,Mwanza",
  "Bungulwa,Kwimba,Mwanza",
  "Bupamwa,Kwimba,Mwanza",
  "Fukalo,Kwimba,Mwanza",
  "Hungumalwa,Kwimba,Mwanza",
  "Igongwa,Kwimba,Mwanza",
  "Ilula,Kwimba,Mwanza",
  "Iseni,Kwimba,Mwanza",
  "Kikubiji,Kwimba,Mwanza",
  "Lyoma,Kwimba,Mwanza",
  "Maligisu,Kwimba,Mwanza",
  "Malya,Kwimba,Mwanza",
  "Mantare,Kwimba,Mwanza",
  "Mhande,Kwimba,Mwanza",
  "Mwabomba,Kwimba,Mwanza",
  "Mwagi,Kwimba,Mwanza",
  "Mwakilyambiti (Mwakilambiti),Kwimba,Mwanza",
  "Mwamala,Kwimba,Mwanza",
  "Mwandu,Kwimba,Mwanza",
  "Mwang'halanga,Kwimba,Mwanza",
  "Mwankulwe,Kwimba,Mwanza",
  "Ng'hundi,Kwimba,Mwanza",
  "Ngudu,Kwimba,Mwanza",
  "Ngulla,Kwimba,Mwanza",
  "Nkalalo,Kwimba,Mwanza",
  "Nyambiti,Kwimba,Mwanza",
  "Nyamilama,Kwimba,Mwanza",
  "Shilembo,Kwimba,Mwanza",
  "Sumve,Kwimba,Mwanza",
  "Walla,Kwimba,Mwanza",
  "Bugomora,Kyerwa,Kagera",
  "Businde,Kyerwa,Kagera",
  "Isingiro,Kyerwa,Kagera",
  "Kaisho,Kyerwa,Kagera",
  "Kamuli,Kyerwa,Kagera",
  "Kibale,Kyerwa,Kagera",
  "Kibingo,Kyerwa,Kagera",
  "Kikukuru,Kyerwa,Kagera",
  "Kimuli,Kyerwa,Kagera",
  "Kyerwa,Kyerwa,Kagera",
  "Mabira,Kyerwa,Kagera",
  "Murongo,Kyerwa,Kagera",
  "Nkwenda,Kyerwa,Kagera",
  "Nyakatuntu,Kyerwa,Kagera",
  "Rukuraijo,Kyerwa,Kagera",
  "Rutunguru,Kyerwa,Kagera",
  "Rwabwere,Kyerwa,Kagera",
  "Songambele,Kyerwa,Kagera",
  "Bujashi,Magu,Mwanza",
  "Bukandwe,Magu,Mwanza",
  "Jinjimili,Magu,Mwanza",
  "Kahangara,Magu,Mwanza",
  "Kisesa,Magu,Mwanza",
  "Kitongo Sima,Magu,Mwanza",
  "Kongolo,Magu,Mwanza",
  "Lubugu,Magu,Mwanza",
  "Lutale,Magu,Mwanza",
  "Magu Mjini,Magu,Mwanza",
  "Mwamabanza,Magu,Mwanza",
  "Mwamanga,Magu,Mwanza",
  "Ng'haya,Magu,Mwanza",
  "Nkungulu,Magu,Mwanza",
  "Nyanguge,Magu,Mwanza",
  "Nyigogo,Magu,Mwanza",
  "Shishani,Magu,Mwanza",
  "Sukuma,Magu,Mwanza",
  "Badi,Maswa,Simiyu",
  "Binza,Maswa,Simiyu",
  "Buchambi,Maswa,Simiyu",
  "Budekwa,Maswa,Simiyu",
  "Busilili,Maswa,Simiyu",
  "Dakama,Maswa,Simiyu",
  "Ipililo,Maswa,Simiyu",
  "Isanga,Maswa,Simiyu",
  "Kadoto,Maswa,Simiyu",
  "Kulimi,Maswa,Simiyu",
  "Lalago,Maswa,Simiyu",
  "Malampaka,Maswa,Simiyu",
  "Masela,Maswa,Simiyu",
  "Mpindo,Maswa,Simiyu",
  "Mwamanenge,Maswa,Simiyu",
  "Mwamashimba,Maswa,Simiyu",
  "Mwang'honoli,Maswa,Simiyu",
  "Nguliguli,Maswa,Simiyu",
  "Ng'wigwa,Maswa,Simiyu",
  "Nyabubinza,Maswa,Simiyu",
  "Nyalikungu,Maswa,Simiyu",
  "Senani,Maswa,Simiyu",
  "Seng'wa,Maswa,Simiyu",
  "Shishiyu,Maswa,Simiyu",
  "Sukuma,Maswa,Simiyu",
  "Zanzui,Maswa,Simiyu",
  "Bukandwe,Mbogwe,Geita",
  "Ikobe,Mbogwe,Geita",
  "Ikunguigazi,Mbogwe,Geita",
  "Ilolangulu,Mbogwe,Geita",
  "Iponya,Mbogwe,Geita",
  "Isebya,Mbogwe,Geita",
  "Lugunga,Mbogwe,Geita",
  "Lulembela,Mbogwe,Geita",
  "Masumbwe,Mbogwe,Geita",
  "Mbogwe,Mbogwe,Geita",
  "Nanda,Mbogwe,Geita",
  "Ngemo (Mgemo),Mbogwe,Geita",
  "Ng'homolwa,Mbogwe,Geita",
  "Nyakafulu,Mbogwe,Geita",
  "Nyasato,Mbogwe,Geita",
  "Ushirika,Mbogwe,Geita",
  "Bukundi,Meatu,Simiyu",
  "Imalaseko,Meatu,Simiyu",
  "Itinje,Meatu,Simiyu",
  "Kimali,Meatu,Simiyu",
  "Kisesa,Meatu,Simiyu",
  "Lingeka,Meatu,Simiyu",
  "Lubiga,Meatu,Simiyu",
  "Mwabuma,Meatu,Simiyu",
  "Mwabusalu,Meatu,Simiyu",
  "Mwabuzo,Meatu,Simiyu",
  "Mwakisandu,Meatu,Simiyu",
  "Mwamalole,Meatu,Simiyu",
  "Mwamanimba,Meatu,Simiyu",
  "Mwamanongu,Meatu,Simiyu",
  "Mwamishali,Meatu,Simiyu",
  "Mwandoya,Meatu,Simiyu",
  "Mwangundo,Meatu,Simiyu",
  "Mwanhuzi,Meatu,Simiyu",
  "Mwanjolo,Meatu,Simiyu",
  "Mwanyahina,Meatu,Simiyu",
  "Mwasengela,Meatu,Simiyu",
  "Ng'hoboko,Meatu,Simiyu",
  "Nkoma,Meatu,Simiyu",
  "Sakasaka,Meatu,Simiyu",
  "Tindabuligi,Meatu,Simiyu",
  "Bugandika,Missenyi,Kagera",
  "Bugorora,Missenyi,Kagera",
  "Buyango,Missenyi,Kagera",
  "Bwanjai,Missenyi,Kagera",
  "Gera,Missenyi,Kagera",
  "Ishozi,Missenyi,Kagera",
  "Ishunju,Missenyi,Kagera",
  "Kakunyu,Missenyi,Kagera",
  "Kanyigo,Missenyi,Kagera",
  "Kashenye,Missenyi,Kagera",
  "Kassambya,Missenyi,Kagera",
  "Kilimilile (Kilimilil),Missenyi,Kagera",
  "Kitobo,Missenyi,Kagera",
  "Kyaka,Missenyi,Kagera",
  "Mabale,Missenyi,Kagera",
  "Minziro,Missenyi,Kagera",
  "Mushasha,Missenyi,Kagera",
  "Mutukula,Missenyi,Kagera",
  "Nsunga,Missenyi,Kagera",
  "Ruzinga,Missenyi,Kagera",
  "Buhingo,Misungwi,Mwanza",
  "Bulemeji,Misungwi,Mwanza",
  "Busongo,Misungwi,Mwanza",
  "Fella,Misungwi,Mwanza",
  "Gulumungu,Misungwi,Mwanza",
  "Idetemya,Misungwi,Mwanza",
  "Igokelo,Misungwi,Mwanza",
  "Ilalambogo,Misungwi,Mwanza",
  "Ilujamate,Misungwi,Mwanza",
  "Isesa,Misungwi,Mwanza",
  "Kanyelele,Misungwi,Mwanza",
  "Kasololo,Misungwi,Mwanza",
  "Kijima,Misungwi,Mwanza",
  "Koromije,Misungwi,Mwanza",
  "Lubili,Misungwi,Mwanza",
  "Mabuki,Misungwi,Mwanza",
  "Mamaye,Misungwi,Mwanza",
  "Mbarika,Misungwi,Mwanza",
  "Misasi (Masasi),Misungwi,Mwanza",
  "Misungwi,Misungwi,Mwanza",
  "Mondo,Misungwi,Mwanza",
  "Mwaniko,Misungwi,Mwanza",
  "Nhundulu,Misungwi,Mwanza",
  "Shilalo,Misungwi,Mwanza",
  "Sumbugu,Misungwi,Mwanza",
  "Ukiriguru,Misungwi,Mwanza",
  "Usagara,Misungwi,Mwanza",
  "Biirabo,Muleba,Kagera",
  "Bisheke,Muleba,Kagera",
  "Buganguzi,Muleba,Kagera",
  "Buhangaza,Muleba,Kagera",
  "Bulyakashaju,Muleba,Kagera",
  "Bumbire,Muleba,Kagera",
  "Bureza,Muleba,Kagera",
  "Burungura,Muleba,Kagera",
  "Goziba,Muleba,Kagera",
  "Gwanseli,Muleba,Kagera",
  "Ibuga,Muleba,Kagera",
  "Ijumbi,Muleba,Kagera",
  "Ikondo,Muleba,Kagera",
  "Ikuza,Muleba,Kagera",
  "Izigo,Muleba,Kagera",
  "Kabirizi,Muleba,Kagera",
  "Kagoma,Muleba,Kagera",
  "Kamachumu,Muleba,Kagera",
  "Karambi,Muleba,Kagera",
  "Kasharunga,Muleba,Kagera",
  "Kashasha,Muleba,Kagera",
  "Katoke,Muleba,Kagera",
  "Kerebe,Muleba,Kagera",
  "Kibanga,Muleba,Kagera",
  "Kikuku,Muleba,Kagera",
  "Kimwani,Muleba,Kagera",
  "Kishanda,Muleba,Kagera",
  "Kyebitembe,Muleba,Kagera",
  "Mafumbo,Muleba,Kagera",
  "Magata Karutanga,Muleba,Kagera",
  "Mayondwe,Muleba,Kagera",
  "Mazinga Kisiwa,Muleba,Kagera",
  "Mubunda,Muleba,Kagera",
  "Muhutwe,Muleba,Kagera",
  "Muleba,Muleba,Kagera",
  "Mushabago,Muleba,Kagera",
  "Ngenge,Muleba,Kagera",
  "Nshamba,Muleba,Kagera",
  "Nyakabango,Muleba,Kagera",
  "Nyakatanga,Muleba,Kagera",
  "Ruhanga,Muleba,Kagera",
  "Rulanda,Muleba,Kagera",
  "Rutoro,Muleba,Kagera",
  "Buhare,Musoma Municipal,Mara",
  "Bweri,Musoma Municipal,Mara",
  "Iringo,Musoma Municipal,Mara",
  "Kamunyonge,Musoma Municipal,Mara",
  "Kigera,Musoma Municipal,Mara",
  "Kitaji,Musoma Municipal,Mara",
  "Makoko,Musoma Municipal,Mara",
  "Mukendo,Musoma Municipal,Mara",
  "Mwigobero,Musoma Municipal,Mara",
  "Mwisenge,Musoma Municipal,Mara",
  "Nyakato,Musoma Municipal,Mara",
  "Nyamatare,Musoma Municipal,Mara",
  "Nyasho,Musoma Municipal,Mara",
  "Bugarama,Ngara,Kagera",
  "Bukiriro,Ngara,Kagera",
  "Kabanga,Ngara,Kagera",
  "Kanazi,Ngara,Kagera",
  "Kasulo,Ngara,Kagera",
  "Keza,Ngara,Kagera",
  "Kibimba,Ngara,Kagera",
  "Kirushya,Ngara,Kagera",
  "Mabawe,Ngara,Kagera",
  "Mbuba,Ngara,Kagera",
  "Muganza,Ngara,Kagera",
  "Mugoma,Ngara,Kagera",
  "Murukulazo,Ngara,Kagera",
  "Murusagamba,Ngara,Kagera",
  "Ngara Mjini,Ngara,Kagera",
  "Ntobeye,Ngara,Kagera",
  "Nyakisasa,Ngara,Kagera",
  "Nyamiyaga,Ngara,Kagera",
  "Rulenge,Ngara,Kagera",
  "Rusumo,Ngara,Kagera",
  "Buhongwa,Nyamagana Municipal,Mwanza",
  "Butimba,Nyamagana Municipal,Mwanza",
  "Igogo,Nyamagana Municipal,Mwanza",
  "Igoma,Nyamagana Municipal,Mwanza",
  "Isamilo,Nyamagana Municipal,Mwanza",
  "Mahina,Nyamagana Municipal,Mwanza",
  "Mbugani,Nyamagana Municipal,Mwanza",
  "Mikuyuni (Mkuyuni),Nyamagana Municipal,Mwanza",
  "Mirongo,Nyamagana Municipal,Mwanza",
  "Mkolani,Nyamagana Municipal,Mwanza",
  "Nyamagana,Nyamagana Municipal,Mwanza",
  "Pamba,Nyamagana Municipal,Mwanza",
  "Bukwimba,Nyang'hwale,Geita",
  "Busolwa,Nyang'hwale,Geita",
  "Izunya,Nyang'hwale,Geita",
  "Kafita,Nyang'hwale,Geita",
  "Kakora (Kakura),Nyang'hwale,Geita",
  "Kharumwa,Nyang'hwale,Geita",
  "Mwingiro,Nyang'hwale,Geita",
  "Nyabulanda,Nyang'hwale,Geita",
  "Nyang'hwale,Nyang'hwale,Geita",
  "Nyijundu,Nyang'hwale,Geita",
  "Nyugwa,Nyang'hwale,Geita",
  "Shabaka,Nyang'hwale,Geita",
  "Bukura,Rorya,Mara",
  "Bukwe,Rorya,Mara",
  "Goribe,Rorya,Mara",
  "Ikoma,Rorya,Mara",
  "Kigunga,Rorya,Mara",
  "Kirogo,Rorya,Mara",
  "Kisumwa,Rorya,Mara",
  "Kitembe,Rorya,Mara",
  "Komuge,Rorya,Mara",
  "Koryo,Rorya,Mara",
  "Kyang'ombe,Rorya,Mara",
  "Mirare,Rorya,Mara",
  "Mkoma,Rorya,Mara",
  "Nyahongo,Rorya,Mara",
  "Nyamagaro,Rorya,Mara",
  "Nyamtinga,Rorya,Mara",
  "Nyamunga,Rorya,Mara",
  "Nyathorogo,Rorya,Mara",
  "Rabour,Rorya,Mara",
  "Roche,Rorya,Mara",
  "Tai,Rorya,Mara",
  "Bulyaheke,Sengerema,Mwanza",
  "Bupandwa,Sengerema,Mwanza",
  "Busisi,Sengerema,Mwanza",
  "Buyagu,Sengerema,Mwanza",
  "Buzilasoga,Sengerema,Mwanza",
  "Chifunfu (Chifumfu),Sengerema,Mwanza",
  "Ibisabageni,Sengerema,Mwanza",
  "Igalula,Sengerema,Mwanza",
  "Igulumuki,Sengerema,Mwanza",
  "Irenza,Sengerema,Mwanza",
  "Kafunzo,Sengerema,Mwanza",
  "Kagunga,Sengerema,Mwanza",
  "Kalebezo,Sengerema,Mwanza",
  "Kasenyi,Sengerema,Mwanza",
  "Kasungamile,Sengerema,Mwanza",
  "Katunguru,Sengerema,Mwanza",
  "Katwe,Sengerema,Mwanza",
  "Kazunzu,Sengerema,Mwanza",
  "Kishinda,Sengerema,Mwanza",
  "Lugata,Sengerema,Mwanza",
  "Maisome,Sengerema,Mwanza",
  "Mwabaluhi (Mwambului),Sengerema,Mwanza",
  "Nyakaliro,Sengerema,Mwanza",
  "Nyakasasa,Sengerema,Mwanza",
  "Nyakasungwa (Nyakasunga),Sengerema,Mwanza",
  "Nyamatongo,Sengerema,Mwanza",
  "Nyamazugo,Sengerema,Mwanza",
  "Nyampande,Sengerema,Mwanza",
  "Nyampulukano,Sengerema,Mwanza",
  "Nyanzenda,Sengerema,Mwanza",
  "Nyatukala,Sengerema,Mwanza",
  "Nyehunge,Sengerema,Mwanza",
  "Sima,Sengerema,Mwanza",
  "Tabaruka,Sengerema,Mwanza",
  "Busawe,Serengeti,Mara",
  "Geitasamo,Serengeti,Mara",
  "Ikoma,Serengeti,Mara",
  "Issenye,Serengeti,Mara",
  "Kebanchabancha,Serengeti,Mara",
  "Kenyamonta,Serengeti,Mara",
  "Kisaka,Serengeti,Mara",
  "Kisangura,Serengeti,Mara",
  "Kyambahi,Serengeti,Mara",
  "Machochwe,Serengeti,Mara",
  "Magange,Serengeti,Mara",
  "Majimoto,Serengeti,Mara",
  "Manchira,Serengeti,Mara",
  "Mbalibali,Serengeti,Mara",
  "Morotonga,Serengeti,Mara",
  "Mosongo,Serengeti,Mara",
  "Mugumu,Serengeti,Mara",
  "Natta,Serengeti,Mara",
  "Nyamatare,Serengeti,Mara",
  "Nyambureti,Serengeti,Mara",
  "Nyamoko,Serengeti,Mara",
  "Nyansurura,Serengeti,Mara",
  "Rigicha,Serengeti,Mara",
  "Ring'wani,Serengeti,Mara",
  "Rung'abure,Serengeti,Mara",
  "Sedeco,Serengeti,Mara",
  "Stendi Kuu,Serengeti,Mara",
  "Uwanja wa Ndege,Serengeti,Mara",
  "Chamaguha,Shinyanga Municipal,Shinyanga",
  "Chibe,Shinyanga Municipal,Shinyanga",
  "Ibadakuli,Shinyanga Municipal,Shinyanga",
  "Ibinzamata,Shinyanga Municipal,Shinyanga",
  "Kambarage,Shinyanga Municipal,Shinyanga",
  "Kitangili,Shinyanga Municipal,Shinyanga",
  "Kizumbi,Shinyanga Municipal,Shinyanga",
  "Kolandoto,Shinyanga Municipal,Shinyanga",
  "Lubaga,Shinyanga Municipal,Shinyanga",
  "Masekelo,Shinyanga Municipal,Shinyanga",
  "Mwamalili,Shinyanga Municipal,Shinyanga",
  "Mwawaza,Shinyanga Municipal,Shinyanga",
  "Ndala,Shinyanga Municipal,Shinyanga",
  "Ndembezi,Shinyanga Municipal,Shinyanga",
  "Ngokolo,Shinyanga Municipal,Shinyanga",
  "Old Shinyanga,Shinyanga Municipal,Shinyanga",
  "Shinyanga Mjini,Shinyanga Municipal,Shinyanga",
  "Binagi,Tarime,Mara",
  "Bomani,Tarime,Mara",
  "Bumera,Tarime,Mara",
  "Genyange,Tarime,Mara",
  "Gorong'a,Tarime,Mara",
  "Itiryo,Tarime,Mara",
  "Kemambo,Tarime,Mara",
  "Kentare,Tarime,Mara",
  "Kibasuka,Tarime,Mara",
  "Kiore,Tarime,Mara",
  "Komaswa,Tarime,Mara",
  "Manga,Tarime,Mara",
  "Matongo,Tarime,Mara",
  "Mbogi,Tarime,Mara",
  "Muriba,Tarime,Mara",
  "Mwema,Tarime,Mara",
  "Nyakonga,Tarime,Mara",
  "Nyamaranga,Tarime,Mara",
  "Nyamisangura,Tarime,Mara",
  "Nyamwaga,Tarime,Mara",
  "Nyandoto,Tarime,Mara",
  "Nyansincha (Nyansicha),Tarime,Mara",
  "Nyanungu,Tarime,Mara",
  "Nyarero,Tarime,Mara",
  "Nyarokoba,Tarime,Mara",
  "Pemba,Tarime,Mara",
  "Sabasaba,Tarime,Mara",
  "Sirari,Tarime,Mara",
  "Susuni,Tarime,Mara",
  "Turwa,Tarime,Mara",
  "Bukanda,Ukerewe,Mwanza",
  "Bukiko (Bukiro),Ukerewe,Mwanza",
  "Bukindo,Ukerewe,Mwanza",
  "Bukongo,Ukerewe,Mwanza",
  "Bukungu,Ukerewe,Mwanza",
  "Bwiro,Ukerewe,Mwanza",
  "Bwisya,Ukerewe,Mwanza",
  "Igalla (Igala),Ukerewe,Mwanza",
  "Ilangala,Ukerewe,Mwanza",
  "Irugwa,Ukerewe,Mwanza",
  "Kagera,Ukerewe,Mwanza",
  "Kagunguli,Ukerewe,Mwanza",
  "Kakerege,Ukerewe,Mwanza",
  "Mukituntu,Ukerewe,Mwanza",
  "Muriti,Ukerewe,Mwanza",
  "Murutunguru,Ukerewe,Mwanza",
  "Nakatunguru,Ukerewe,Mwanza",
  "Namagondo,Ukerewe,Mwanza",
  "Namilembe,Ukerewe,Mwanza",
  "Nansio,Ukerewe,Mwanza",
  "Nduruma,Ukerewe,Mwanza",
  "Ngoma,Ukerewe,Mwanza",
  "Nkilizya,Ukerewe,Mwanza",
  "Nyamanga,Ukerewe,Mwanza",
  "Buhingu,Uvinza,Kigoma",
  "Igalula,Uvinza,Kigoma",
  "Ilagala,Uvinza,Kigoma",
  "Itebula,Uvinza,Kigoma",
  "Kalya,Uvinza,Kigoma",
  "Kandaga,Uvinza,Kigoma",
  "Kazuramimba,Uvinza,Kigoma",
  "Mganza,Uvinza,Kigoma",
  "Mtego wa Noti,Uvinza,Kigoma",
  "Nguruka,Uvinza,Kigoma",
  "Sigunga,Uvinza,Kigoma",
  "Simbo,Uvinza,Kigoma",
  "Sunuka,Uvinza,Kigoma",
  "Uvinza,Uvinza,Kigoma",
  "Baraa,Arusha City,Arusha",
  "Daraja Mbili,Arusha City,Arusha",
  "Elerai,Arusha City,Arusha",
  "Engutoto,Arusha City,Arusha",
  "Kaloleni,Arusha City,Arusha",
  "Kati,Arusha City,Arusha",
  "Kimandolu,Arusha City,Arusha",
  "Lemara,Arusha City,Arusha",
  "Levolosi,Arusha City,Arusha",
  "Moshono,Arusha City,Arusha",
  "Ngarenaro,Arusha City,Arusha",
  "Olasiti,Arusha City,Arusha",
  "Oloirien (Oloirieni),Arusha City,Arusha",
  "Sekei,Arusha City,Arusha",
  "Sokoni I,Arusha City,Arusha",
  "Sombetini,Arusha City,Arusha",
  "Terrat,Arusha City,Arusha",
  "Themi,Arusha City,Arusha",
  "Unga Limited,Arusha City,Arusha",
  "Bangata,Arusha,Arusha",
  "Bwawani,Arusha,Arusha",
  "Ilkiding'a,Arusha,Arusha",
  "Kimnyaki,Arusha,Arusha",
  "Kiranyi,Arusha,Arusha",
  "Kisongo,Arusha,Arusha",
  "Mateves,Arusha,Arusha",
  "Mlangarini,Arusha,Arusha",
  "Moivo,Arusha,Arusha",
  "Mussa,Arusha,Arusha",
  "Mwandeti,Arusha,Arusha",
  "Nduruma,Arusha,Arusha",
  "Oldonyosambu,Arusha,Arusha",
  "Oljoro,Arusha,Arusha",
  "Olkokola,Arusha,Arusha",
  "Olmotonyi,Arusha,Arusha",
  "Olorieni,Arusha,Arusha",
  "Oltoroto,Arusha,Arusha",
  "Oltrumet,Arusha,Arusha",
  "Sambasha,Arusha,Arusha",
  "Sokoni II,Arusha,Arusha",
  "Hai Mjini,Hai,Kilimanjaro",
  "KIA,Hai,Kilimanjaro",
  "Machame Kaskazini,Hai,Kilimanjaro",
  "Machame Kusini,Hai,Kilimanjaro",
  "Machame Magharibi,Hai,Kilimanjaro",
  "Machame Mashariki,Hai,Kilimanjaro",
  "Machame Narumu,Hai,Kilimanjaro",
  "Machame Uroki,Hai,Kilimanjaro",
  "Machame Weruweru,Hai,Kilimanjaro",
  "Masama Kati,Hai,Kilimanjaro",
  "Masama Kusini,Hai,Kilimanjaro",
  "Masama Magharibi,Hai,Kilimanjaro",
  "Masama Mashariki,Hai,Kilimanjaro",
  "Masama Rundugai,Hai,Kilimanjaro",
  "Balangidalalu (Balagidalalu),Hanang,Manyara",
  "Bassodesh,Hanang,Manyara",
  "Bassotu,Hanang,Manyara",
  "Dirma,Hanang,Manyara",
  "Endasak,Hanang,Manyara",
  "Endasiwold,Hanang,Manyara",
  "Ganana,Hanang,Manyara",
  "Gehandu,Hanang,Manyara",
  "Gendabi,Hanang,Manyara",
  "Getanuwas,Hanang,Manyara",
  "Gidahababieg,Hanang,Manyara",
  "Gisambalang,Hanang,Manyara",
  "Gitting (Giting),Hanang,Manyara",
  "Hidet,Hanang,Manyara",
  "Hirbadaw,Hanang,Manyara",
  "Katesh,Hanang,Manyara",
  "Laghanga,Hanang,Manyara",
  "Lalaji,Hanang,Manyara",
  "Masakta,Hanang,Manyara",
  "Masqaroda,Hanang,Manyara",
  "Measkron (Maskron),Hanang,Manyara",
  "Mogitu,Hanang,Manyara",
  "Nangwa,Hanang,Manyara",
  "Simbay,Hanang,Manyara",
  "Sirop,Hanang,Manyara",
  "Baray,Karatu,Arusha",
  "Buger,Karatu,Arusha",
  "Daa,Karatu,Arusha",
  "Endabash,Karatu,Arusha",
  "Endamaghang,Karatu,Arusha",
  "Endamarariek,Karatu,Arusha",
  "Ganako,Karatu,Arusha",
  "Kansay,Karatu,Arusha",
  "Karatu,Karatu,Arusha",
  "Mang'ola,Karatu,Arusha",
  "Mbulumbulu,Karatu,Arusha",
  "Oldeani,Karatu,Arusha",
  "Qurus,Karatu,Arusha",
  "Rhotia,Karatu,Arusha",
  "Jaila,Kilindi,Tanga",
  "Kibirashi,Kilindi,Tanga",
  "Kikunde,Kilindi,Tanga",
  "Kilindi,Kilindi,Tanga",
  "Kilwa,Kilindi,Tanga",
  "Kimbe,Kilindi,Tanga",
  "Kisangasa,Kilindi,Tanga",
  "Kwediboma,Kilindi,Tanga",
  "Kwekivu,Kilindi,Tanga",
  "Lwande,Kilindi,Tanga",
  "Mabalanga,Kilindi,Tanga",
  "Masagulu (Masagalu),Kilindi,Tanga",
  "Mkindi,Kilindi,Tanga",
  "Msanja,Kilindi,Tanga",
  "Mvungwe,Kilindi,Tanga",
  "Negero,Kilindi,Tanga",
  "Pagwi,Kilindi,Tanga",
  "Saunyi,Kilindi,Tanga",
  "Songe,Kilindi,Tanga",
  "Tunguli,Kilindi,Tanga",
  "Bwagamoyo,Kiteto,Manyara",
  "Chapakazi,Kiteto,Manyara",
  "Dongo,Kiteto,Manyara",
  "Dosidosi,Kiteto,Manyara",
  "Engusero,Kiteto,Manyara",
  "Kibaya,Kiteto,Manyara",
  "Kijungu,Kiteto,Manyara",
  "Lengatei,Kiteto,Manyara",
  "Loolera,Kiteto,Manyara",
  "Magungu,Kiteto,Manyara",
  "Makame,Kiteto,Manyara",
  "Matui,Kiteto,Manyara",
  "Namelock,Kiteto,Manyara",
  "Ndedo,Kiteto,Manyara",
  "Njoro,Kiteto,Manyara",
  "Olboloti (Olboroti),Kiteto,Manyara",
  "Partimbo,Kiteto,Manyara",
  "Songambele,Kiteto,Manyara",
  "Sunya,Kiteto,Manyara",
  "Eleng'ata Dapash,Longido,Arusha",
  "Engarenaibor,Longido,Arusha",
  "Engikaret,Longido,Arusha",
  "Gelai Lumbwa,Longido,Arusha",
  "Gelai Meirugoi,Longido,Arusha",
  "Ilorienito,Longido,Arusha",
  "Kamwanga,Longido,Arusha",
  "Kimokouwa,Longido,Arusha",
  "Kitumbeine (Kitumbeine),Longido,Arusha",
  "Longido,Longido,Arusha",
  "Matale,Longido,Arusha",
  "Mundarara,Longido,Arusha",
  "Namanga,Longido,Arusha",
  "Olmolog,Longido,Arusha",
  "Orbomba,Longido,Arusha",
  "Tingatinga,Longido,Arusha",
  "Baga,Lushoto,Tanga",
  "Bumbuli,Lushoto,Tanga",
  "Dule 'B',Lushoto,Tanga",
  "Dule 'M',Lushoto,Tanga",
  "Funta,Lushoto,Tanga",
  "Gare,Lushoto,Tanga",
  "Hemtoye,Lushoto,Tanga",
  "Kilole,Lushoto,Tanga",
  "Kwai,Lushoto,Tanga",
  "Kwekanga,Lushoto,Tanga",
  "Kwemashai,Lushoto,Tanga",
  "Kwemshasha,Lushoto,Tanga",
  "Lukozi,Lushoto,Tanga",
  "Lunguza,Lushoto,Tanga",
  "Lushoto,Lushoto,Tanga",
  "Maheza Ngulu,Lushoto,Tanga",
  "Makanya,Lushoto,Tanga",
  "Malibwi,Lushoto,Tanga",
  "Malindi,Lushoto,Tanga",
  "Mamba,Lushoto,Tanga",
  "Manolo,Lushoto,Tanga",
  "Mayo,Lushoto,Tanga",
  "Mbaramo,Lushoto,Tanga",
  "Mbuzii,Lushoto,Tanga",
  "Mgwashi,Lushoto,Tanga",
  "Milingano (Milingano),Lushoto,Tanga",
  "Mlalo,Lushoto,Tanga",
  "Mlola,Lushoto,Tanga",
  "Mnazi,Lushoto,Tanga",
  "Mng'aro,Lushoto,Tanga",
  "Mponde,Lushoto,Tanga",
  "Mtae,Lushoto,Tanga",
  "Mwangoi,Lushoto,Tanga",
  "Ngulwi,Lushoto,Tanga",
  "Ngwelo,Lushoto,Tanga",
  "Nkongoi,Lushoto,Tanga",
  "Rangwi,Lushoto,Tanga",
  "Shume,Lushoto,Tanga",
  "Soni,Lushoto,Tanga",
  "Sunga,Lushoto,Tanga",
  "Tamota,Lushoto,Tanga",
  "Ubiri,Lushoto,Tanga",
  "Usambara,Lushoto,Tanga",
  "Vuga,Lushoto,Tanga",
  "Ayamaami,Mbulu,Manyara",
  "Ayamohe,Mbulu,Manyara",
  "Bargish,Mbulu,Manyara",
  "Bashay,Mbulu,Manyara",
  "Daudi,Mbulu,Manyara",
  "Dinamu,Mbulu,Manyara",
  "Dongobesh,Mbulu,Manyara",
  "Endagikot,Mbulu,Manyara",
  "Endamilay,Mbulu,Manyara",
  "Eshkesh,Mbulu,Manyara",
  "Gehandu,Mbulu,Manyara",
  "Geterer,Mbulu,Manyara",
  "Gidihim,Mbulu,Manyara",
  "Gunyoda,Mbulu,Manyara",
  "Hayderer,Mbulu,Manyara",
  "Haydom,Mbulu,Manyara",
  "Imboru,Mbulu,Manyara",
  "Kainam,Mbulu,Manyara",
  "Maghang,Mbulu,Manyara",
  "Marang,Mbulu,Manyara",
  "Maretadu,Mbulu,Manyara",
  "Masieda,Mbulu,Manyara",
  "Masqaroda,Mbulu,Manyara",
  "Murray,Mbulu,Manyara",
  "Nahasey,Mbulu,Manyara",
  "Nambisi,Mbulu,Manyara",
  "Sanu Baray,Mbulu,Manyara",
  "Tlawi,Mbulu,Manyara",
  "Tumati,Mbulu,Manyara",
  "Uhuru,Mbulu,Manyara",
  "Yaeda Ampa,Mbulu,Manyara",
  "Yaeda Chini,Mbulu,Manyara",
  "Akheri,Meru,Arusha",
  "Kikatiti,Meru,Arusha",
  "Kikwe,Meru,Arusha",
  "King'ori,Meru,Arusha",
  "Leguruki,Meru,Arusha",
  "Maji ya Chai,Meru,Arusha",
  "Makiba,Meru,Arusha",
  "Maroroni,Meru,Arusha",
  "Mbuguni,Meru,Arusha",
  "Ngarenanyuki,Meru,Arusha",
  "Nkoanrua,Meru,Arusha",
  "Nkoaranga,Meru,Arusha",
  "Nkoarisambu,Meru,Arusha",
  "Poli,Meru,Arusha",
  "Seela Sing'isi,Meru,Arusha",
  "Songoro,Meru,Arusha",
  "Usa River,Meru,Arusha",
  "Boma,Mkinga,Tanga",
  "Bosha,Mkinga,Tanga",
  "Bwiti,Mkinga,Tanga",
  "Daluni,Mkinga,Tanga",
  "Doda,Mkinga,Tanga",
  "Duga,Mkinga,Tanga",
  "Gombero,Mkinga,Tanga",
  "Kigongoi,Mkinga,Tanga",
  "Kwale,Mkinga,Tanga",
  "Manza,Mkinga,Tanga",
  "Mapatano,Mkinga,Tanga",
  "Maramba,Mkinga,Tanga",
  "Mayomboni,Mkinga,Tanga",
  "Mhinduro,Mkinga,Tanga",
  "Mkinga,Mkinga,Tanga",
  "Mnyenzani,Mkinga,Tanga",
  "Moa,Mkinga,Tanga",
  "Mtimbwani,Mkinga,Tanga",
  "Mwakijembe,Mkinga,Tanga",
  "Parungu Kasera,Mkinga,Tanga",
  "Sigaya,Mkinga,Tanga",
  "Engaruka,Monduli,Arusha",
  "Engutoto,Monduli,Arusha",
  "Esilalei,Monduli,Arusha",
  "Lepurko,Monduli,Arusha",
  "Lolkisale,Monduli,Arusha",
  "Majengo,Monduli,Arusha",
  "Makuyuni,Monduli,Arusha",
  "Meserani,Monduli,Arusha",
  "Moita,Monduli,Arusha",
  "Monduli Juu,Monduli,Arusha",
  "Monduli Mjini,Monduli,Arusha",
  "Mswakini,Monduli,Arusha",
  "Mto wa Mbu,Monduli,Arusha",
  "Selela,Monduli,Arusha",
  "Sepeko,Monduli,Arusha",
  "Boma Mbuzi,Moshi Municipal,Kilimanjaro",
  "Bondeni,Moshi Municipal,Kilimanjaro",
  "Kaloleni,Moshi Municipal,Kilimanjaro",
  "Karanga,Moshi Municipal,Kilimanjaro",
  "Kiboriloni,Moshi Municipal,Kilimanjaro",
  "Kilimanjaro,Moshi Municipal,Kilimanjaro",
  "Kiusa,Moshi Municipal,Kilimanjaro",
  "Korongoni,Moshi Municipal,Kilimanjaro",
  "Longuo B,Moshi Municipal,Kilimanjaro",
  "Majengo,Moshi Municipal,Kilimanjaro",
  "Mawenzi,Moshi Municipal,Kilimanjaro",
  "Mfumuni,Moshi Municipal,Kilimanjaro",
  "Miembeni,Moshi Municipal,Kilimanjaro",
  "Mji Mpya,Moshi Municipal,Kilimanjaro",
  "Msaranga,Moshi Municipal,Kilimanjaro",
  "Ng'ambo,Moshi Municipal,Kilimanjaro",
  "Njoro,Moshi Municipal,Kilimanjaro",
  "Pasua,Moshi Municipal,Kilimanjaro",
  "Rau,Moshi Municipal,Kilimanjaro",
  "Shirimatunda,Moshi Municipal,Kilimanjaro",
  "Soweto,Moshi Municipal,Kilimanjaro",
  "Amani,Muheza,Tanga",
  "Bwembwera,Muheza,Tanga",
  "Genge,Muheza,Tanga",
  "Kicheba,Muheza,Tanga",
  "Kigombe,Muheza,Tanga",
  "Kilulu,Muheza,Tanga",
  "Kisiwani,Muheza,Tanga",
  "Kwafungo,Muheza,Tanga",
  "Kwakifua,Muheza,Tanga",
  "Kwemkabala,Muheza,Tanga",
  "Lusanga,Muheza,Tanga",
  "Magila,Muheza,Tanga",
  "Magoroto,Muheza,Tanga",
  "Majengo,Muheza,Tanga",
  "Masuguru,Muheza,Tanga",
  "Mbaramo,Muheza,Tanga",
  "Mbomole,Muheza,Tanga",
  "Mhamba,Muheza,Tanga",
  "Misalai,Muheza,Tanga",
  "Misozwe,Muheza,Tanga",
  "Mkuzi,Muheza,Tanga",
  "Mlingoni (Mlingano),Muheza,Tanga",
  "Mpapayu,Muheza,Tanga",
  "Mtindiro,Muheza,Tanga",
  "Ngomeni,Muheza,Tanga",
  "Nkumba,Muheza,Tanga",
  "Pande Darajani,Muheza,Tanga",
  "Potwe,Muheza,Tanga",
  "Songa,Muheza,Tanga",
  "Tanganyika,Muheza,Tanga",
  "Tingeni,Muheza,Tanga",
  "Tongwe,Muheza,Tanga",
  "Zirai,Muheza,Tanga",
  "Chomvu,Mwanga,Kilimanjaro",
  "Jipe,Mwanga,Kilimanjaro",
  "Kifula,Mwanga,Kilimanjaro",
  "Kighare,Mwanga,Kilimanjaro",
  "Kigonigoni (Kigoningoni),Mwanga,Kilimanjaro",
  "Kileo,Mwanga,Kilimanjaro",
  "Kilomeni,Mwanga,Kilimanjaro",
  "Kirongwe,Mwanga,Kilimanjaro",
  "Kirya,Mwanga,Kilimanjaro",
  "Kivisini,Mwanga,Kilimanjaro",
  "Kwakoa,Mwanga,Kilimanjaro",
  "Lang'ata,Mwanga,Kilimanjaro",
  "Lembeni,Mwanga,Kilimanjaro",
  "Mgagao,Mwanga,Kilimanjaro",
  "Msangeni,Mwanga,Kilimanjaro",
  "Mwanga,Mwanga,Kilimanjaro",
  "Mwaniko,Mwanga,Kilimanjaro",
  "Ngujini,Mwanga,Kilimanjaro",
  "Shighatini,Mwanga,Kilimanjaro",
  "Toloha,Mwanga,Kilimanjaro",
  "Alailelai,Ngorongoro,Arusha",
  "Arash,Ngorongoro,Arusha",
  "Digodigo,Ngorongoro,Arusha",
  "Enduleni (Endulen),Ngorongoro,Arusha",
  "Enguserosambu,Ngorongoro,Arusha",
  "Kakesio,Ngorongoro,Arusha",
  "Maalon,Ngorongoro,Arusha",
  "Malambo,Ngorongoro,Arusha",
  "Nainokanoka,Ngorongoro,Arusha",
  "Naiyobi,Ngorongoro,Arusha",
  "Ngorongoro,Ngorongoro,Arusha",
  "Olbalbal,Ngorongoro,Arusha",
  "Oldonyo-Sambu,Ngorongoro,Arusha",
  "Oloipiri,Ngorongoro,Arusha",
  "Oloirien,Ngorongoro,Arusha",
  "Ololosokwan,Ngorongoro,Arusha",
  "Orgosorok,Ngorongoro,Arusha",
  "Pinyinyi,Ngorongoro,Arusha",
  "Sale,Ngorongoro,Arusha",
  "Samunge,Ngorongoro,Arusha",
  "Soit-Sambu,Ngorongoro,Arusha",
  "Bushiri,Pangani,Tanga",
  "Bweni,Pangani,Tanga",
  "Kimang'a,Pangani,Tanga",
  "Kipumbwi,Pangani,Tanga",
  "Madanga,Pangani,Tanga",
  "Mikunguni,Pangani,Tanga",
  "Mkalamo,Pangani,Tanga",
  "Mkwaja,Pangani,Tanga",
  "Mwera,Pangani,Tanga",
  "Pangani Magharibi,Pangani,Tanga",
  "Pangani Mashariki,Pangani,Tanga",
  "Tungamaa,Pangani,Tanga",
  "Ubangaa,Pangani,Tanga",
  "Holili,Rombo,Kilimanjaro",
  "Katangara Mrere,Rombo,Kilimanjaro",
  "Kelamfua Mokala,Rombo,Kilimanjaro",
  "Keni Aleni,Rombo,Kilimanjaro",
  "Keni Mengeni,Rombo,Kilimanjaro",
  "Kirongo Samanga,Rombo,Kilimanjaro",
  "Kirwa Keni,Rombo,Kilimanjaro",
  "Kisale Masangara,Rombo,Kilimanjaro",
  "Kitirima Kingachi,Rombo,Kilimanjaro",
  "Mahida,Rombo,Kilimanjaro",
  "Makiidi,Rombo,Kilimanjaro",
  "Mamsera,Rombo,Kilimanjaro",
  "Manda,Rombo,Kilimanjaro",
  "Marangu Kitowo,Rombo,Kilimanjaro",
  "Mengwe,Rombo,Kilimanjaro",
  "Motamburu Kitendeni,Rombo,Kilimanjaro",
  "Mrao Keryo,Rombo,Kilimanjaro",
  "Nanjala Reha,Rombo,Kilimanjaro",
  "Ngoyoni,Rombo,Kilimanjaro",
  "Olele,Rombo,Kilimanjaro",
  "Shimbi,Rombo,Kilimanjaro",
  "Tarakea Motamburu,Rombo,Kilimanjaro",
  "Ubetu Kahe,Rombo,Kilimanjaro",
  "Ushiri Ikuini,Rombo,Kilimanjaro",
  "Bendera,Same,Kilimanjaro",
  "Bombo,Same,Kilimanjaro",
  "Bwambo,Same,Kilimanjaro",
  "Chome,Same,Kilimanjaro",
  "Hedaru,Same,Kilimanjaro",
  "Kalemawe,Same,Kilimanjaro",
  "Kihurio,Same,Kilimanjaro",
  "Kirangare,Same,Kilimanjaro",
  "Kisima,Same,Kilimanjaro",
  "Kisiwani,Same,Kilimanjaro",
  "Lugulu,Same,Kilimanjaro",
  "Mabilioni,Same,Kilimanjaro",
  "Makanya,Same,Kilimanjaro",
  "Maore,Same,Kilimanjaro",
  "Mhezi,Same,Kilimanjaro",
  "Mpinji,Same,Kilimanjaro",
  "Mshewa,Same,Kilimanjaro",
  "Msindo,Same,Kilimanjaro",
  "Mtii,Same,Kilimanjaro",
  "Mwembe,Same,Kilimanjaro",
  "Myamba,Same,Kilimanjaro",
  "Ndungu,Same,Kilimanjaro",
  "Njoro,Same,Kilimanjaro",
  "Ruvu,Same,Kilimanjaro",
  "Same,Same,Kilimanjaro",
  "Stesheni,Same,Kilimanjaro",
  "Suji,Same,Kilimanjaro",
  "Vudee,Same,Kilimanjaro",
  "Vuje,Same,Kilimanjaro",
  "Vumari,Same,Kilimanjaro",
  "Vunta,Same,Kilimanjaro",
  "Biriri,Siha,Kilimanjaro",
  "Gararagua,Siha,Kilimanjaro",
  "Karansi,Siha,Kilimanjaro",
  "Kashashi (Kashisha),Siha,Kilimanjaro",
  "Livishi,Siha,Kilimanjaro",
  "Makiwaru,Siha,Kilimanjaro",
  "Naeny (Ivaeny),Siha,Kilimanjaro",
  "Nasai,Siha,Kilimanjaro",
  "Ndumeti,Siha,Kilimanjaro",
  "Ngarenairobi,Siha,Kilimanjaro",
  "Olkolili,Siha,Kilimanjaro",
  "Sanya Juu,Siha,Kilimanjaro",
  "Emboreet,Simanjiro,Manyara",
  "Endiamtu (Endiantu),Simanjiro,Manyara",
  "Endonyongijape,Simanjiro,Manyara",
  "Kitwai,Simanjiro,Manyara",
  "Komolo,Simanjiro,Manyara",
  "Liborsoit,Simanjiro,Manyara",
  "Loiborsiret,Simanjiro,Manyara",
  "Mrerani (Mererani),Simanjiro,Manyara",
  "Msitu wa Tembo,Simanjiro,Manyara",
  "Naberera,Simanjiro,Manyara",
  "Naisinyai,Simanjiro,Manyara",
  "Ngorika,Simanjiro,Manyara",
  "Oljoro No. 5,Simanjiro,Manyara",
  "Orkesumet (Orkesmet),Simanjiro,Manyara",
  "Ruvu Remiti,Simanjiro,Manyara",
  "Shambarai,Simanjiro,Manyara",
  "Terrat,Simanjiro,Manyara",
  "Chalangwa,Chunya,Mbeya",
  "Chokaa,Chunya,Mbeya",
  "Ifumbo,Chunya,Mbeya",
  "Itewe,Chunya,Mbeya",
  "Kambikatoto,Chunya,Mbeya",
  "Lupa Tingatinga,Chunya,Mbeya",
  "Luwalaje,Chunya,Mbeya",
  "Mafyeko,Chunya,Mbeya",
  "Makongorosi (Makongolosi),Chunya,Mbeya",
  "Mamba,Chunya,Mbeya",
  "Matundasi,Chunya,Mbeya",
  "Matwiga,Chunya,Mbeya",
  "Mbugani,Chunya,Mbeya",
  "Mkola,Chunya,Mbeya",
  "Mtanila,Chunya,Mbeya",
  "Sangambi,Chunya,Mbeya",
  "Bupigu,Ileje,Songwe",
  "Chitete,Ileje,Songwe",
  "Ibaba,Ileje,Songwe",
  "Ikinga,Ileje,Songwe",
  "Isongole,Ileje,Songwe",
  "Itale,Ileje,Songwe",
  "Itumba,Ileje,Songwe",
  "Kafule,Ileje,Songwe",
  "Kalembo,Ileje,Songwe",
  "Lubanda,Ileje,Songwe",
  "Luswisi,Ileje,Songwe",
  "Malangali,Ileje,Songwe",
  "Mbebe,Ileje,Songwe",
  "Mlale,Ileje,Songwe",
  "Ndola,Ileje,Songwe",
  "Ngulilo,Ileje,Songwe",
  "Ngulugulu,Ileje,Songwe",
  "Sange,Ileje,Songwe",
  "Gangilonga,Iringa Municipal,Iringa",
  "Ilala,Iringa Municipal,Iringa",
  "Isakalilo,Iringa Municipal,Iringa",
  "Kihesa,Iringa Municipal,Iringa",
  "Kitanzini,Iringa Municipal,Iringa",
  "Kitwiru,Iringa Municipal,Iringa",
  "Kwakilosa,Iringa Municipal,Iringa",
  "Makorongoni,Iringa Municipal,Iringa",
  "Mivinjeni,Iringa Municipal,Iringa",
  "Mkwawa,Iringa Municipal,Iringa",
  "Mlandege,Iringa Municipal,Iringa",
  "Mshindo,Iringa Municipal,Iringa",
  "Mtwivila,Iringa Municipal,Iringa",
  "Mwangata,Iringa Municipal,Iringa",
  "Nduli,Iringa Municipal,Iringa",
  "Ruaha,Iringa Municipal,Iringa",
  "Kasanga,Kalambo,Rukwa",
  "Katazi,Kalambo,Rukwa",
  "Katete,Kalambo,Rukwa",
  "Kilesha,Kalambo,Rukwa",
  "Kisumba,Kalambo,Rukwa",
  "Legeza Mwendo,Kalambo,Rukwa",
  "Mambwekenya (Mabwekenya),Kalambo,Rukwa",
  "Matai,Kalambo,Rukwa",
  "Mkali,Kalambo,Rukwa",
  "Mkowe,Kalambo,Rukwa",
  "Mnamba,Kalambo,Rukwa",
  "Msanzi,Kalambo,Rukwa",
  "Mwazye,Kalambo,Rukwa",
  "Mwembenkoswe,Kalambo,Rukwa",
  "Mwimbi,Kalambo,Rukwa",
  "Sopa,Kalambo,Rukwa",
  "Ulumi,Kalambo,Rukwa",
  "Boma la Ng'ombe,Kilolo,Iringa",
  "Dabaga,Kilolo,Iringa",
  "Ibumu,Kilolo,Iringa",
  "Idete,Kilolo,Iringa",
  "Ihimbo,Kilolo,Iringa",
  "Ilula,Kilolo,Iringa",
  "Image,Kilolo,Iringa",
  "Irole,Kilolo,Iringa",
  "Kimala,Kilolo,Iringa",
  "Lugalo,Kilolo,Iringa",
  "Mahenge,Kilolo,Iringa",
  "Masisiwe,Kilolo,Iringa",
  "Mlafu,Kilolo,Iringa",
  "Mtitu,Kilolo,Iringa",
  "Ng'ang'ange,Kilolo,Iringa",
  "Ng'uruhe,Kilolo,Iringa",
  "Nyalumbu,Kilolo,Iringa",
  "Ruaha Mbuyuni,Kilolo,Iringa",
  "Udekwa,Kilolo,Iringa",
  "Uhambingeto,Kilolo,Iringa",
  "Ukumbi,Kilolo,Iringa",
  "Ukwega,Kilolo,Iringa",
  "Bujonde,Kyela,Mbeya",
  "Busale,Kyela,Mbeya",
  "Ikama,Kyela,Mbeya",
  "Ikimba,Kyela,Mbeya",
  "Ikolo,Kyela,Mbeya",
  "Ipande,Kyela,Mbeya",
  "Ipinda,Kyela,Mbeya",
  "Itope,Kyela,Mbeya",
  "Kajunjumele,Kyela,Mbeya",
  "Katumba Songwe,Kyela,Mbeya",
  "Kyela,Kyela,Mbeya",
  "Lusungo,Kyela,Mbeya",
  "Makwale,Kyela,Mbeya",
  "Matema,Kyela,Mbeya",
  "Muungano,Kyela,Mbeya",
  "Mwaya,Kyela,Mbeya",
  "Ndobo,Kyela,Mbeya",
  "Ngana,Kyela,Mbeya",
  "Ngonga,Kyela,Mbeya",
  "Talatala,Kyela,Mbeya",
  "Ibumi,Ludewa,Njombe",
  "Iwela,Ludewa,Njombe",
  "Kilondo,Ludewa,Njombe",
  "Lifuma,Ludewa,Njombe",
  "Luana,Ludewa,Njombe",
  "Ludende,Ludewa,Njombe",
  "Ludewa,Ludewa,Njombe",
  "Lugarawa,Ludewa,Njombe",
  "Luilo,Ludewa,Njombe",
  "Lumbila,Ludewa,Njombe",
  "Lupanga,Ludewa,Njombe",
  "Lupingu,Ludewa,Njombe",
  "Madilu,Ludewa,Njombe",
  "Madope,Ludewa,Njombe",
  "Makonde,Ludewa,Njombe",
  "Manda,Ludewa,Njombe",
  "Masasi,Ludewa,Njombe",
  "Mavanga,Ludewa,Njombe",
  "Mawengi,Ludewa,Njombe",
  "Milo,Ludewa,Njombe",
  "Mkongobaki,Ludewa,Njombe",
  "Mlangali,Ludewa,Njombe",
  "Mundindi,Ludewa,Njombe",
  "Nkomang'ombe,Ludewa,Njombe",
  "Ruhuhu,Ludewa,Njombe",
  "Mafinga Town,Ludewa,Njombe",
  "Boma,Ludewa,Njombe",
  "Kinyanambo,Ludewa,Njombe",
  "Sao Hill,Ludewa,Njombe",
  "Makambako Town,Ludewa,Njombe",
  "Kitandililo,Ludewa,Njombe",
  "Lyamkena,Ludewa,Njombe",
  "Mahongole,Ludewa,Njombe",
  "Mjimwema,Ludewa,Njombe",
  "Mlowa,Ludewa,Njombe",
  "Mwembetogwa,Ludewa,Njombe",
  "Ubena,Ludewa,Njombe",
  "Utengule,Ludewa,Njombe",
  "Bulongwa,Makete,Njombe",
  "Ikuwo,Makete,Njombe",
  "Iniho,Makete,Njombe",
  "Ipelele,Makete,Njombe",
  "Ipepo,Makete,Njombe",
  "Isapulano,Makete,Njombe",
  "Itundu,Makete,Njombe",
  "Iwawa,Makete,Njombe",
  "Kigala,Makete,Njombe",
  "Kigulu,Makete,Njombe",
  "Kipagilo (Kipagalo),Makete,Njombe",
  "Kitulo,Makete,Njombe",
  "Lupalilo,Makete,Njombe",
  "Lupila,Makete,Njombe",
  "Luwumbu,Makete,Njombe",
  "Mang'oto,Makete,Njombe",
  "Matamba,Makete,Njombe",
  "Mbalatse,Makete,Njombe",
  "Mfumbi,Makete,Njombe",
  "Mlondwe,Makete,Njombe",
  "Tandala,Makete,Njombe",
  "Ukwama,Makete,Njombe",
  "Kambarage,Mbinga,Ruvuma",
  "Kigonsera,Mbinga,Ruvuma",
  "Kihangi Mahuka,Mbinga,Ruvuma",
  "Kihungu,Mbinga,Ruvuma",
  "Kikolo,Mbinga,Ruvuma",
  "Kilimani,Mbinga,Ruvuma",
  "Kipapa,Mbinga,Ruvuma",
  "Kipololo,Mbinga,Ruvuma",
  "Kitanda,Mbinga,Ruvuma",
  "Kitumbalomo,Mbinga,Ruvuma",
  "Kitura,Mbinga,Ruvuma",
  "Langiro,Mbinga,Ruvuma",
  "Linda,Mbinga,Ruvuma",
  "Litembo,Mbinga,Ruvuma",
  "Litumbandyosi,Mbinga,Ruvuma",
  "Luwaita,Mbinga,Ruvuma",
  "Maguu,Mbinga,Ruvuma",
  "Mapera,Mbinga,Ruvuma",
  "Matiri,Mbinga,Ruvuma",
  "Mbangamao,Mbinga,Ruvuma",
  "Mbinga Mjini,Mbinga,Ruvuma",
  "Mbuji,Mbinga,Ruvuma",
  "Mkako,Mbinga,Ruvuma",
  "Mkalanga (Mikalanga),Mbinga,Ruvuma",
  "Mkumbi,Mbinga,Ruvuma",
  "Mpapa,Mbinga,Ruvuma",
  "Mpepai,Mbinga,Ruvuma",
  "Myangayanga,Mbinga,Ruvuma",
  "Namswea,Mbinga,Ruvuma",
  "Ngima,Mbinga,Ruvuma",
  "Nyoni,Mbinga,Ruvuma",
  "Ruanda,Mbinga,Ruvuma",
  "Ukata,Mbinga,Ruvuma",
  "Utiri,Mbinga,Ruvuma",
  "Bara,Mbozi,Songwe",
  "Halungu,Mbozi,Songwe",
  "Igamba,Mbozi,Songwe",
  "Ihanda,Mbozi,Songwe",
  "Ipunga,Mbozi,Songwe",
  "Isandula,Mbozi,Songwe",
  "Isansa,Mbozi,Songwe",
  "Itaka,Mbozi,Songwe",
  "Iyula,Mbozi,Songwe",
  "Mlangali,Mbozi,Songwe",
  "Mlowo,Mbozi,Songwe",
  "Msia,Mbozi,Songwe",
  "Myovizi,Mbozi,Songwe",
  "Nambinzo,Mbozi,Songwe",
  "Nanyala,Mbozi,Songwe",
  "Nyimbili (Nyambili),Mbozi,Songwe",
  "Ruanda,Mbozi,Songwe",
  "Vwawa,Mbozi,Songwe",
  "Ikuba,Mlele,Katavi",
  "Ilela,Mlele,Katavi",
  "Ilunde,Mlele,Katavi",
  "Inyonga,Mlele,Katavi",
  "Itenka,Mlele,Katavi",
  "Kapalala,Mlele,Katavi",
  "Kasansa,Mlele,Katavi",
  "Kasokola,Mlele,Katavi",
  "Kibaoni,Mlele,Katavi",
  "Litapunga,Mlele,Katavi",
  "Machimboni,Mlele,Katavi",
  "Magamba,Mlele,Katavi",
  "Majimoto,Mlele,Katavi",
  "Mamba,Mlele,Katavi",
  "Mbede,Mlele,Katavi",
  "Mtapenda,Mlele,Katavi",
  "Mwamapuli,Mlele,Katavi",
  "Nsenkwa,Mlele,Katavi",
  "Nsimbo,Mlele,Katavi",
  "Sitalike,Mlele,Katavi",
  "Ugala,Mlele,Katavi",
  "Urwila (Urwira),Mlele,Katavi",
  "Usevya,Mlele,Katavi",
  "Utende,Mlele,Katavi",
  "Chilulumo,Momba,Songwe",
  "Chitete,Momba,Songwe",
  "Chiwezi,Momba,Songwe",
  "Ivuna,Momba,Songwe",
  "Kamsamba,Momba,Songwe",
  "Kapele,Momba,Songwe",
  "Mkulwe,Momba,Songwe",
  "Mpapa,Momba,Songwe",
  "Msangano,Momba,Songwe",
  "Myunga,Momba,Songwe",
  "Ndalambo (Ndalembo),Momba,Songwe",
  "Nkangamo,Momba,Songwe",
  "Nzoka,Momba,Songwe",
  "Ikola,Mpanda,Katavi",
  "Kabungu,Mpanda,Katavi",
  "Kapalamsenga,Mpanda,Katavi",
  "Karema,Mpanda,Katavi",
  "Katuma,Mpanda,Katavi",
  "Mishamo,Mpanda,Katavi",
  "Mpandandogo,Mpanda,Katavi",
  "Mwese,Mpanda,Katavi",
  "Sibwesa,Mpanda,Katavi",
  "Mpanda Town,Mpanda,Katavi",
  "Ilembo,Mpanda,Katavi",
  "Kakese,Mpanda,Katavi",
  "Kashaulili,Mpanda,Katavi",
  "Kawajense,Mpanda,Katavi",
  "Makanyagio,Mpanda,Katavi",
  "Misunkumilo,Mpanda,Katavi",
  "Mpanda Hotel,Mpanda,Katavi",
  "Nsemulwa,Mpanda,Katavi",
  "Shanwe,Mpanda,Katavi",
  "Bumilayinga,Mufindi,Iringa",
  "Idunda,Mufindi,Iringa",
  "Ifwagi,Mufindi,Iringa",
  "Igombavu (Igombavanu),Mufindi,Iringa",
  "Igowole,Mufindi,Iringa",
  "Ihalimba,Mufindi,Iringa",
  "Ihanu,Mufindi,Iringa",
  "Ihowanza,Mufindi,Iringa",
  "Ikweha,Mufindi,Iringa",
  "Isalavanu,Mufindi,Iringa",
  "Itandula,Mufindi,Iringa",
  "Kasanga,Mufindi,Iringa",
  "Kibengu,Mufindi,Iringa",
  "Kiyowela,Mufindi,Iringa",
  "Luhunga (Luhanga),Mufindi,Iringa",
  "Makungu,Mufindi,Iringa",
  "Malangali,Mufindi,Iringa",
  "Mapanda,Mufindi,Iringa",
  "Mbalamaziwa,Mufindi,Iringa",
  "Mdabulo,Mufindi,Iringa",
  "Mninga,Mufindi,Iringa",
  "Mpanga,Mufindi,Iringa",
  "Mtambula,Mufindi,Iringa",
  "Mtwango,Mufindi,Iringa",
  "Nyololo,Mufindi,Iringa",
  "Rungemba,Mufindi,Iringa",
  "Sadani,Mufindi,Iringa",
  "Hanga,Namtumbo,Ruvuma",
  "Kitanda,Namtumbo,Ruvuma",
  "Ligera,Namtumbo,Ruvuma",
  "Likuyuseka,Namtumbo,Ruvuma",
  "Limamu,Namtumbo,Ruvuma",
  "Litola,Namtumbo,Ruvuma",
  "Luchili,Namtumbo,Ruvuma",
  "Luegu,Namtumbo,Ruvuma",
  "Lusewa,Namtumbo,Ruvuma",
  "Magazini,Namtumbo,Ruvuma",
  "Mchomoro,Namtumbo,Ruvuma",
  "Mgombasi,Namtumbo,Ruvuma",
  "Mkongo,Namtumbo,Ruvuma",
  "Mputa,Namtumbo,Ruvuma",
  "Msindo,Namtumbo,Ruvuma",
  "Namabengo,Namtumbo,Ruvuma",
  "Namtumbo,Namtumbo,Ruvuma",
  "Rwinga,Namtumbo,Ruvuma",
  "Chala,Nkasi,Rukwa",
  "Isale,Nkasi,Rukwa",
  "Kabwe,Nkasi,Rukwa",
  "Kala,Nkasi,Rukwa",
  "Kate,Nkasi,Rukwa",
  "Kipande,Nkasi,Rukwa",
  "Kipili,Nkasi,Rukwa",
  "Kirando,Nkasi,Rukwa",
  "Korongwe,Nkasi,Rukwa",
  "Mkwamba,Nkasi,Rukwa",
  "Mtenga,Nkasi,Rukwa",
  "Namanyere,Nkasi,Rukwa",
  "Ninde,Nkasi,Rukwa",
  "Nkandasi,Nkasi,Rukwa",
  "Nkomolo,Nkasi,Rukwa",
  "Sintali,Nkasi,Rukwa",
  "Wampembe,Nkasi,Rukwa",
  "Chiwanda,Nyasa,Ruvuma",
  "Kihagara,Nyasa,Ruvuma",
  "Kilosa,Nyasa,Ruvuma",
  "Kingerikiti,Nyasa,Ruvuma",
  "Liparamba,Nyasa,Ruvuma",
  "Lipingo,Nyasa,Ruvuma",
  "Lituhi,Nyasa,Ruvuma",
  "Liuli,Nyasa,Ruvuma",
  "Liwundi,Nyasa,Ruvuma",
  "Luhangarasi,Nyasa,Ruvuma",
  "Mbaha,Nyasa,Ruvuma",
  "Mbambabay,Nyasa,Ruvuma",
  "Mtipwili,Nyasa,Ruvuma",
  "Ngumbo,Nyasa,Ruvuma",
  "Tingi,Nyasa,Ruvuma",
  "Bombambili,Songea Municipal,Ruvuma",
  "Lilambo,Songea Municipal,Ruvuma",
  "Lizaboni,Songea Municipal,Ruvuma",
  "Majengo,Songea Municipal,Ruvuma",
  "Matarawe,Songea Municipal,Ruvuma",
  "Mateka,Songea Municipal,Ruvuma",
  "Matogoro,Songea Municipal,Ruvuma",
  "Mfaranyaki,Songea Municipal,Ruvuma",
  "Misufini,Songea Municipal,Ruvuma",
  "Mjimwema,Songea Municipal,Ruvuma",
  "Mletele,Songea Municipal,Ruvuma",
  "Msamala,Songea Municipal,Ruvuma",
  "Mshangano,Songea Municipal,Ruvuma",
  "Mwengemshindo,Songea Municipal,Ruvuma",
  "Ndilimalitembo,Songea Municipal,Ruvuma",
  "Ruhuwiko,Songea Municipal,Ruvuma",
  "Ruvuma,Songea Municipal,Ruvuma",
  "SeedFarm,Songea Municipal,Ruvuma",
  "Songea Mjini,Songea Municipal,Ruvuma",
  "Subira,Songea Municipal,Ruvuma",
  "Tanga,Songea Municipal,Ruvuma",
  "Chanji,Sumbawanga Municipal,Rukwa",
  "Izia,Sumbawanga Municipal,Rukwa",
  "Kasense,Sumbawanga Municipal,Rukwa",
  "Katandala,Sumbawanga Municipal,Rukwa",
  "Kizwite,Sumbawanga Municipal,Rukwa",
  "Majengo,Sumbawanga Municipal,Rukwa",
  "Malangali,Sumbawanga Municipal,Rukwa",
  "Matanga,Sumbawanga Municipal,Rukwa",
  "Mazwi,Sumbawanga Municipal,Rukwa",
  "Milanzi,Sumbawanga Municipal,Rukwa",
  "Mollo,Sumbawanga Municipal,Rukwa",
  "Ntendo,Sumbawanga Municipal,Rukwa",
  "Old Sumbawanga,Sumbawanga Municipal,Rukwa",
  "Pito,Sumbawanga Municipal,Rukwa",
  "Senga,Sumbawanga Municipal,Rukwa",
  "Jakika,Tunduru,Ruvuma",
  "Kalulu,Tunduru,Ruvuma",
  "Kidodoma,Tunduru,Ruvuma",
  "Ligoma,Tunduru,Ruvuma",
  "Ligunga,Tunduru,Ruvuma",
  "Lukumbule,Tunduru,Ruvuma",
  "Majengo,Tunduru,Ruvuma",
  "Marumba,Tunduru,Ruvuma",
  "Masonya,Tunduru,Ruvuma",
  "Matemanga,Tunduru,Ruvuma",
  "Mbati,Tunduru,Ruvuma",
  "Mbesa,Tunduru,Ruvuma",
  "Mchangani,Tunduru,Ruvuma",
  "Mchesi,Tunduru,Ruvuma",
  "Mchoteka,Tunduru,Ruvuma",
  "Mchuluka,Tunduru,Ruvuma",
  "Mindu,Tunduru,Ruvuma",
  "Misechela,Tunduru,Ruvuma",
  "Mlingoti Magharibi,Tunduru,Ruvuma",
  "Mlingoti Mashariki,Tunduru,Ruvuma",
  "Mtina,Tunduru,Ruvuma",
  "Muhuwesi,Tunduru,Ruvuma",
  "Nakapanya,Tunduru,Ruvuma",
  "Nakayaya,Tunduru,Ruvuma",
  "Nalasi Magharibi,Tunduru,Ruvuma",
  "Nalasi Mashariki,Tunduru,Ruvuma",
  "Namasakata,Tunduru,Ruvuma",
  "Namiungo,Tunduru,Ruvuma",
  "Nampungu,Tunduru,Ruvuma",
  "Namwinyu,Tunduru,Ruvuma",
  "Nandembo,Tunduru,Ruvuma",
  "Nanjoka,Tunduru,Ruvuma",
  "Ngapa,Tunduru,Ruvuma",
  "Sisikwasisi,Tunduru,Ruvuma",
  "Tuwemacho,Tunduru,Ruvuma",
  "Igima,Wanging'ombe,Njombe",
  "Igosi,Wanging'ombe,Njombe",
  "Igwachanya,Wanging'ombe,Njombe",
  "Ilembula,Wanging'ombe,Njombe",
  "Imalinyi,Wanging'ombe,Njombe",
  "Kidugala,Wanging'ombe,Njombe",
  "Kijombe,Wanging'ombe,Njombe",
  "Kipengere,Wanging'ombe,Njombe",
  "Luduga,Wanging'ombe,Njombe",
  "Makoga,Wanging'ombe,Njombe",
  "Mdandu,Wanging'ombe,Njombe",
  "Saja,Wanging'ombe,Njombe",
  "Uhambule,Wanging'ombe,Njombe",
  "Ulembwe,Wanging'ombe,Njombe",
  "Usuka,Wanging'ombe,Njombe",
  "Wangama,Wanging'ombe,Njombe",
  "Wanging'ombe,Wanging'ombe,Njombe",
  "Chachani,Chake Chake,Pemba Kusini",
  "Chanjaani,Chake Chake,Pemba Kusini",
  "Chonga,Chake Chake,Pemba Kusini",
  "Dodo,Chake Chake,Pemba Kusini",
  "Kibokoni,Chake Chake,Pemba Kusini",
  "Kichungwani,Chake Chake,Pemba Kusini",
  "Kilindi,Chake Chake,Pemba Kusini",
  "Kwale,Chake Chake,Pemba Kusini",
  "Madungu,Chake Chake,Pemba Kusini",
  "Matale,Chake Chake,Pemba Kusini",
  "Mbuzini,Chake Chake,Pemba Kusini",
  "Mfikiwa,Chake Chake,Pemba Kusini",
  "Mgelema,Chake Chake,Pemba Kusini",
  "Mgogoni,Chake Chake,Pemba Kusini",
  "Michungwani,Chake Chake,Pemba Kusini",
  "Mkoroshoni,Chake Chake,Pemba Kusini",
  "Msingini,Chake Chake,Pemba Kusini",
  "Mvumoni,Chake Chake,Pemba Kusini",
  "Ndagoni,Chake Chake,Pemba Kusini",
  "Ng'ambwa,Chake Chake,Pemba Kusini",
  "Pujini,Chake Chake,Pemba Kusini",
  "Shungi,Chake Chake,Pemba Kusini",
  "Tibirinzi,Chake Chake,Pemba Kusini",
  "Uwandani,Chake Chake,Pemba Kusini",
  "Vitongoji,Chake Chake,Pemba Kusini",
  "Wara,Chake Chake,Pemba Kusini",
  "Wawi,Chake Chake,Pemba Kusini",
  "Wesha,Chake Chake,Pemba Kusini",
  "Ziwani,Chake Chake,Pemba Kusini",
  "Bandamaji,Kaskazini A,Unguja Kaskazini",
  "Bwereu,Kaskazini A,Unguja Kaskazini",
  "Chaani Kubwa,Kaskazini A,Unguja Kaskazini",
  "Chaani Masingini,Kaskazini A,Unguja Kaskazini",
  "Chutama,Kaskazini A,Unguja Kaskazini",
  "Fukuchani,Kaskazini A,Unguja Kaskazini",
  "Gamba,Kaskazini A,Unguja Kaskazini",
  "Kandwi,Kaskazini A,Unguja Kaskazini",
  "Kibeni,Kaskazini A,Unguja Kaskazini",
  "Kidombo,Kaskazini A,Unguja Kaskazini",
  "Kidoti,Kaskazini A,Unguja Kaskazini",
  "Kigomani,Kaskazini A,Unguja Kaskazini",
  "Kigunda,Kaskazini A,Unguja Kaskazini",
  "Kijini,Kaskazini A,Unguja Kaskazini",
  "Kikobweni,Kaskazini A,Unguja Kaskazini",
  "Kilimani,Kaskazini A,Unguja Kaskazini",
  "Kilindi,Kaskazini A,Unguja Kaskazini",
  "Kinyasini,Kaskazini A,Unguja Kaskazini",
  "Kisongoni,Kaskazini A,Unguja Kaskazini",
  "Kivunge,Kaskazini A,Unguja Kaskazini",
  "Matemwe,Kaskazini A,Unguja Kaskazini",
  "Mchenza Shauri (Mcheza Shauri),Kaskazini A,Unguja Kaskazini",
  "Mkokotoni,Kaskazini A,Unguja Kaskazini",
  "Mkwajuni,Kaskazini A,Unguja Kaskazini",
  "Moga,Kaskazini A,Unguja Kaskazini",
  "Mto wa Pwani,Kaskazini A,Unguja Kaskazini",
  "Muwange,Kaskazini A,Unguja Kaskazini",
  "Nungwi,Kaskazini A,Unguja Kaskazini",
  "Pale,Kaskazini A,Unguja Kaskazini",
  "Pitanazako,Kaskazini A,Unguja Kaskazini",
  "Potoa (Potowa),Kaskazini A,Unguja Kaskazini",
  "Pwani Mchangani,Kaskazini A,Unguja Kaskazini",
  "Tazari,Kaskazini A,Unguja Kaskazini",
  "Tumbatu Gomani,Kaskazini A,Unguja Kaskazini",
  "Tumbatu Jongowe,Kaskazini A,Unguja Kaskazini",
  "Uvivini,Kaskazini A,Unguja Kaskazini",
  "Donge Karange,Kaskazini B,Unguja Kaskazini",
  "Donge Kipange,Kaskazini B,Unguja Kaskazini",
  "Donge Mbiji,Kaskazini B,Unguja Kaskazini",
  "Donge Mchangani,Kaskazini B,Unguja Kaskazini",
  "Donge Mtambile,Kaskazini B,Unguja Kaskazini",
  "Donge Vijibweni,Kaskazini B,Unguja Kaskazini",
  "Fujoni,Kaskazini B,Unguja Kaskazini",
  "Kidanzini,Kaskazini B,Unguja Kaskazini",
  "Kilombero,Kaskazini B,Unguja Kaskazini",
  "Kinduni,Kaskazini B,Unguja Kaskazini",
  "Kiombamvua,Kaskazini B,Unguja Kaskazini",
  "Kitope,Kaskazini B,Unguja Kaskazini",
  "Kiwengwa,Kaskazini B,Unguja Kaskazini",
  "Mafufuni,Kaskazini B,Unguja Kaskazini",
  "Mahonda,Kaskazini B,Unguja Kaskazini",
  "Makoba,Kaskazini B,Unguja Kaskazini",
  "Mangapwani,Kaskazini B,Unguja Kaskazini",
  "Matetema,Kaskazini B,Unguja Kaskazini",
  "Mbaleni,Kaskazini B,Unguja Kaskazini",
  "Mgambo,Kaskazini B,Unguja Kaskazini",
  "Misufini,Kaskazini B,Unguja Kaskazini",
  "Mkadini,Kaskazini B,Unguja Kaskazini",
  "Mkataleni,Kaskazini B,Unguja Kaskazini",
  "Mnyimbi,Kaskazini B,Unguja Kaskazini",
  "Muwanda,Kaskazini B,Unguja Kaskazini",
  "Njia ya Mtoni,Kaskazini B,Unguja Kaskazini",
  "Pangeni,Kaskazini B,Unguja Kaskazini",
  "Upenja,Kaskazini B,Unguja Kaskazini",
  "Zingwezingwe,Kaskazini B,Unguja Kaskazini",
  "Chimba,Micheweni,Pemba Kusini",
  "Finya,Micheweni,Pemba Kusini",
  "Kifundi,Micheweni,Pemba Kusini",
  "Kinowe,Micheweni,Pemba Kusini",
  "Kinyasini,Micheweni,Pemba Kusini",
  "Kiuyu Mbuyuni,Micheweni,Pemba Kusini",
  "Konde,Micheweni,Pemba Kusini",
  "Majenzi,Micheweni,Pemba Kusini",
  "Makangale,Micheweni,Pemba Kusini",
  "Maziwa Ng'ombe,Micheweni,Pemba Kusini",
  "Mgogoni,Micheweni,Pemba Kusini",
  "Micheweni,Micheweni,Pemba Kusini",
  "Mihogoni,Micheweni,Pemba Kusini",
  "Mjini Wingwi,Micheweni,Pemba Kusini",
  "Mlindo,Micheweni,Pemba Kusini",
  "Msuka Magharibi,Micheweni,Pemba Kusini",
  "Msuka Mashariki,Micheweni,Pemba Kusini",
  "Mtemani,Micheweni,Pemba Kusini",
  "Shumba Mjini,Micheweni,Pemba Kusini",
  "Shumba Viamboni,Micheweni,Pemba Kusini",
  "Sizini,Micheweni,Pemba Kusini",
  "Tondooni,Micheweni,Pemba Kusini",
  "Tumbe,Micheweni,Pemba Kusini",
  "Tumbe Mashariki,Micheweni,Pemba Kusini",
  "Wingwi Mapofu,Micheweni,Pemba Kusini",
  "Wingwi Mjananza,Micheweni,Pemba Kusini",
  "Wingwi Njuguni,Micheweni,Pemba Kusini",
  "Mjini Zanzibar,Micheweni,Pemba Kusini",
  "Amani,Micheweni,Pemba Kusini",
  "Chumbuni,Micheweni,Pemba Kusini",
  "Gulioni,Micheweni,Pemba Kusini",
  "Jang'ombe,Micheweni,Pemba Kusini",
  "Karakana,Micheweni,Pemba Kusini",
  "Kidongo Chekundu,Micheweni,Pemba Kusini",
  "Kikwajuni Bondeni,Micheweni,Pemba Kusini",
  "Kikwajuni Juu,Micheweni,Pemba Kusini",
  "Kilimahewa Bondeni,Micheweni,Pemba Kusini",
  "Kilimahewa Juu,Micheweni,Pemba Kusini",
  "Kilimani,Micheweni,Pemba Kusini",
  "Kiponda,Micheweni,Pemba Kusini",
  "Kisima Majongoo,Micheweni,Pemba Kusini",
  "Kisiwandui,Micheweni,Pemba Kusini",
  "Kwaalimsha,Micheweni,Pemba Kusini",
  "Kwaalinatu,Micheweni,Pemba Kusini",
  "Kwahani,Micheweni,Pemba Kusini",
  "Kwamtipura,Micheweni,Pemba Kusini",
  "Kwa Wazee,Micheweni,Pemba Kusini",
  "Magomeni,Micheweni,Pemba Kusini",
  "Makadara,Micheweni,Pemba Kusini",
  "Malindi,Micheweni,Pemba Kusini",
  "Matarumbeta,Micheweni,Pemba Kusini",
  "Mchangani,Micheweni,Pemba Kusini",
  "Meya,Micheweni,Pemba Kusini",
  "Miembeni,Micheweni,Pemba Kusini",
  "Migombani,Micheweni,Pemba Kusini",
  "Mikunguni,Micheweni,Pemba Kusini",
  "Mkele,Micheweni,Pemba Kusini",
  "Mkunazini,Micheweni,Pemba Kusini",
  "Mlandege,Micheweni,Pemba Kusini",
  "Mpendae,Micheweni,Pemba Kusini",
  "Muungano,Micheweni,Pemba Kusini",
  "Mwembeladu,Micheweni,Pemba Kusini",
  "Mwembe Makumbi,Micheweni,Pemba Kusini",
  "Mwembeshauri (Muembeshauri),Micheweni,Pemba Kusini",
  "Mwembetanga (Muembetanga),Micheweni,Pemba Kusini",
  "Nyerere,Micheweni,Pemba Kusini",
  "Rahaleo,Micheweni,Pemba Kusini",
  "Sebleni,Micheweni,Pemba Kusini",
  "Shangani,Micheweni,Pemba Kusini",
  "Shaurimoyo,Micheweni,Pemba Kusini",
  "Sogea,Micheweni,Pemba Kusini",
  "Urusi,Micheweni,Pemba Kusini",
  "Vikokotoni,Micheweni,Pemba Kusini",
  "Chambani,Mkoani,Pemba Kusini",
  "Changaweni,Mkoani,Pemba Kusini",
  "Chokocho,Mkoani,Pemba Kusini",
  "Chumbageni,Mkoani,Pemba Kusini",
  "Jombwe,Mkoani,Pemba Kusini",
  "Kangani,Mkoani,Pemba Kusini",
  "Kendwa,Mkoani,Pemba Kusini",
  "Kengeja,Mkoani,Pemba Kusini",
  "Kisiwa Panza,Mkoani,Pemba Kusini",
  "Kiwani,Mkoani,Pemba Kusini",
  "Kuukuu,Mkoani,Pemba Kusini",
  "Makombeni,Mkoani,Pemba Kusini",
  "Makoongwe,Mkoani,Pemba Kusini",
  "Mbuguani,Mkoani,Pemba Kusini",
  "Mbuyuni,Mkoani,Pemba Kusini",
  "Mgagadu,Mkoani,Pemba Kusini",
  "Michenzani,Mkoani,Pemba Kusini",
  "Minazini,Mkoani,Pemba Kusini",
  "Mizingani,Mkoani,Pemba Kusini",
  "Mjimbini,Mkoani,Pemba Kusini",
  "Mkanyageni,Mkoani,Pemba Kusini",
  "Mkungu,Mkoani,Pemba Kusini",
  "Mtambile,Mkoani,Pemba Kusini",
  "Mtangani,Mkoani,Pemba Kusini",
  "Muambe,Mkoani,Pemba Kusini",
  "Ng'ombeni,Mkoani,Pemba Kusini",
  "Ngwachani,Mkoani,Pemba Kusini",
  "Shamiani,Mkoani,Pemba Kusini",
  "Shidi,Mkoani,Pemba Kusini",
  "Stahabu,Mkoani,Pemba Kusini",
  "Ukutini,Mkoani,Pemba Kusini",
  "Uweleni,Mkoani,Pemba Kusini",
  "Wambaa,Mkoani,Pemba Kusini",
  "Bopwe,Wete,Pemba Kusini",
  "Chwale,Wete,Pemba Kusini",
  "Fundo,Wete,Pemba Kusini",
  "Gando,Wete,Pemba Kusini",
  "Jadida,Wete,Pemba Kusini",
  "Junguni,Wete,Pemba Kusini",
  "Kambini,Wete,Pemba Kusini",
  "Kangagani,Wete,Pemba Kusini",
  "Kinyikani,Wete,Pemba Kusini",
  "Kipangani,Wete,Pemba Kusini",
  "Kisiwani,Wete,Pemba Kusini",
  "Kiungoni,Wete,Pemba Kusini",
  "Kiuyu Kigongoni,Wete,Pemba Kusini",
  "Kiuyu Minungwini,Wete,Pemba Kusini",
  "Kizimbani,Wete,Pemba Kusini",
  "Kojani,Wete,Pemba Kusini",
  "Limbani,Wete,Pemba Kusini",
  "Maziwani,Wete,Pemba Kusini",
  "Mchanga Mdogo,Wete,Pemba Kusini",
  "Mjini Ole,Wete,Pemba Kusini",
  "Mpambani,Wete,Pemba Kusini",
  "Mtambwe Kaskazini,Wete,Pemba Kusini",
  "Mtambwe Kusini,Wete,Pemba Kusini",
  "Mzambarauni Takao,Wete,Pemba Kusini",
  "Ole,Wete,Pemba Kusini",
  "Pandani,Wete,Pemba Kusini",
  "Pembeni,Wete,Pemba Kusini",
  "Piki,Wete,Pemba Kusini",
  "Selem,Wete,Pemba Kusini",
  "Shengejuu,Wete,Pemba Kusini",
  "Ukunjwi,Wete,Pemba Kusini",
  "Utaani,Wete,Pemba Kusini"
];

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];